import _classCallCheck from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/builds/bittnerdevelopmentgroup/film-interactives/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["baseName", "children", "color", "className", "dot", "aria-label"],
    _excluded2 = ["active", "activeClass", "onKeyDown", "onKeyUp", "onBlur", "className", "children", "type"],
    _excluded3 = ["source", "children"],
    _excluded4 = ["isOpen", "reference", "transition", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "timeout", "placement", "modifiers", "strategy", "onFirstUpdate", "enableArrow", "arrowElement", "arrowPadding", "enableFlip", "flipOptions", "offset", "distance", "enablePreventOverflow", "boundary", "preventOverflowOptions", "matchWidth", "children", "className", "style"],
    _excluded5 = ["isOpen", "transition", "reference", "arrowElement", "distance", "boundary", "placement", "modifiers", "strategy", "onFirstUpdate", "hideDelay", "showDelay", "baseName", "bodyClass", "contentClass", "arrowClass", "asLabel", "trigger", "children", "className"],
    _excluded6 = ["baseName", "className", "color", "icon", "size", "variant", "warnOnClick", "tooltipProps", "onClick", "aria-label", "children"],
    _excluded7 = ["baseName", "variant", "icon", "iconRight", "iconOnly", "color", "tooltipProps", "iconClass", "textClass", "className", "children", "aria-label", "aria-labelledby"],
    _excluded8 = ["variant", "children"],
    _excluded9 = ["title", "icon", "dismissible", "tag", "children", "className", "baseName", "iconClass", "headerClass", "titleClass", "dismissClass", "bodyClass", "border", "color", "onDismiss"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["errors", "validateOnChange", "validateOnDOMChange", "validators", "maxLength", "maxLengthRestrictsInput", "onInput", "onDOMChange", "onValidate"],
    _excluded14 = ["type", "checked", "indeterminate", "optionalIndicator", "requiredIndicator", "validators", "description", "thumbnail", "errors", "children", "baseName", "className", "controlClass", "descriptionClass", "inputClass", "thumbnailClass", "checkedClass", "labelClass", "errorsClass", "id", "labelId", "descriptionId", "errorsId", "required", "value", "onChange", "onDOMChange", "onValidate"],
    _excluded15 = ["choices", "selected", "multiple"],
    _excluded16 = ["multiple", "required", "optionalIndicator", "requiredIndicator", "name", "fieldName", "label", "children", "description", "errors", "baseName", "className", "labelClass", "descriptionClass", "errorsClass", "id", "labelId", "descriptionId", "errorsId", "onChange"],
    _excluded17 = ["children"],
    _excluded18 = ["marker", "markerPosition", "children"],
    _excluded19 = ["isOpen", "reducedMotion", "summary", "children", "marker", "markerPosition", "markerTransform", "panel", "className", "baseName", "summaryClass", "markerClass", "contentsOuterClass", "contentsInnerClass", "onCloseStart", "onCloseCancel", "onCloseEnd", "onOpenStart", "onOpenCancel", "onOpenEnd"],
    _excluded20 = ["isSelected", "disabled", "children", "markerClass", "contentsClass", "value"],
    _excluded21 = ["children", "className", "selected", "aria-orientation", "initialFocusIndex", "sort", "optionClass", "markerClass", "contentsClass", "onChange", "onFocusChange"],
    _excluded22 = ["external", "children"],
    _excluded23 = ["disabled", "label", "selected", "marker", "className", "onClick", "onKeyDown", "children"],
    _excluded24 = ["options", "optionProps", "multiselectable", "selected", "onChange", "autofocus", "focusableIndex", "focusWrap", "onOptionFocus", "className", "children", "orientation"],
    _excluded25 = ["children", "disabled", "value", "label", "selected"],
    _excluded26 = ["modal", "children"],
    _excluded27 = ["isOpen", "transition", "reference", "arrowElement", "distance", "boundary", "placement", "modifiers", "strategy", "onFirstUpdate", "hideDelay", "showDelay", "onRequestOpen", "onRequestClose", "title", "hideTitle", "hideCloseButton", "actions", "baseName", "headerClass", "titleClass", "closeButtonClass", "bodyClass", "actionBarClass", "arrowClass", "onClose", "onOpen", "children", "className", "aria-labelledby", "aria-label"],
    _excluded28 = ["progress", "max", "children"],
    _excluded29 = ["progress", "buffer", "reversed", "className"],
    _excluded30 = ["size", "strokeWidth", "progress", "className"],
    _excluded31 = ["label", "hideLabel", "size", "baseName", "labelClass", "className"],
    _excluded32 = ["label", "color", "baseName", "labelClass", "labelPosition", "hideLabel", "size", "className"],
    _excluded33 = ["baseName", "labelClass", "descriptionClass", "checked", "tooltipProps", "children", "className", "description", "disabled", "displayDefault", "label", "tipped", "id", "labelId", "descriptionId", "onClick", "onToggle"],
    _excluded34 = ["dismissible", "baseName", "contentsClass", "dismissClass", "children", "color", "onDismiss", "onClick", "className"],
    _excluded35 = ["multiline", "autoSize", "errors", "validateOnChange", "validateOnDOMChange", "validators", "maxLength", "maxLengthRestrictsInput", "onInput", "onDOMChange", "onValidate"],
    _excluded36 = ["counterStart", "validators", "validateOnChange", "validateOnDOMChange", "requiredIndicator", "optionalIndicator", "multiline", "autoSize", "children", "description", "addonBefore", "addonAfter", "feedback", "errors", "counter", "baseName", "className", "labelClass", "descriptionClass", "groupClass", "inputClass", "addonClass", "feedbackClass", "errorsClass", "counterClass", "invalidClass", "id", "labelId", "descriptionId", "errorsId", "maxLength", "required", "type", "value", "onChange", "onCount", "onDOMChange", "onValidate"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";

/***
 * @wwnds/react v1.3.1
 * Copyright 2019-2021 W. W. Norton & Company
 * Licensed under the MIT license found in the LICENSE file in the root
 * directory at undefined.
 **/
import e, { useMemo as t, useEffect as r, useState as n, createContext as a, useContext as s, useLayoutEffect as o, useRef as i, useCallback as l } from "react";
import c from "classnames";
import d from "react-is";
import u from "react-fast-compare";
import { createPopper as m } from "@popperjs/core";
import h from "lodash/uniqueId";
import { usePopper as p } from "react-popper";
import { CSSTransition as f } from "react-transition-group";
import v, { createPortal as b } from "react-dom";
import { uniqueId as g } from "lodash";
import { MDCLinearProgress as E } from "@material/linear-progress";

function y() {
  return (y = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var w = e.forwardRef(function (_ref, l) {
  var _c;

  var _ref$baseName = _ref.baseName,
      t = _ref$baseName === void 0 ? "nds-badge" : _ref$baseName,
      r = _ref.children,
      n = _ref.color,
      a = _ref.className,
      _ref$dot = _ref.dot,
      s = _ref$dot === void 0 ? !1 : _ref$dot,
      o = _ref["aria-label"],
      i = _objectWithoutProperties(_ref, _excluded);

  var d = c(a, t, (_c = {}, _defineProperty(_c, "".concat(t, "--").concat(n), void 0 !== n), _defineProperty(_c, "".concat(t, "--dot"), !0 === s), _c));
  return r || s ? e.createElement("span", y({
    className: d
  }, i, {
    ref: l,
    "aria-label": s && !o ? "has notification" : o
  }), s ? null : r) : null;
}),
    N = function N(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = [];
  var a = [];
  a = e.isValidElement(t) ? e.Children.toArray(t) : Array.isArray(t) ? t : [t];

  var s = function s(e) {
    return r.every(function (t) {
      return t in e;
    });
  },
      o = function o(e) {
    return r.filter(function (t) {
      return !(t in e);
    });
  };

  return a.forEach(function (t) {
    if (void 0 === t) return 0;

    if ("string" == typeof t || "number" == typeof t) {
      if (r.length) throw new Error(N.MISSING_PROPS(r));
      return n.push(e.createElement("span", {}, t));
    }

    if ("object" == typeof t) {
      if (null === t) return 0;

      if (d.isElement(t)) {
        if (t.type === e.Fragment) return n.push.apply(n, _toConsumableArray(N(t.props.children, r)));
        if (s(t.props)) return n.push(t);
        throw new Error(N.MISSING_PROPS(o(t.props)));
      }

      if (Array.isArray(t)) return t.forEach(function (e) {
        return n.push.apply(n, _toConsumableArray(N(e, r)));
      });
      if (s(t)) return n.push(e.createElement("span", t));
      throw new Error(N.MISSING_PROPS(o(t)));
    }

    throw new Error("Child nodes can be strings, numbers, or React Elements.");
  }), n;
};

N.INVALID_NODES = "Child nodes can be strings, numbers, or React Elements.", N.MISSING_PROPS = function (e) {
  return "Missing required props: ".concat(e.join(", "), ".");
};

var C = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
    _ = function _(e, n) {
  var a = t(function () {
    return Array.isArray(e) ? e : [e];
  }, [e]);
  r(function () {
    var e = function e(_e2) {
      var t = _e2.composedPath();

      a.some(function (e) {
        return e && t.includes(e);
      }) || n && n();
    };

    return a.length && document.addEventListener("click", e), function () {
      document.removeEventListener("click", e);
    };
  }, [a, n]);
};

function k(e) {
  var _n = n(null),
      _n2 = _slicedToArray(_n, 2),
      t = _n2[0],
      a = _n2[1];

  return r(function () {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }, [e, t]), [t, a];
}

var x = a(void 0),
    M = function M(e) {
  return !(!d.isElement(e) || "a" !== e.type && "string" != typeof e.props.href) || !(!d.isFragment(e) || !e.props) && M(e.props.children);
},
    L = function L() {
  return s(x);
},
    $ = C ? o : r,
    O = $,
    S = function S(e) {
  var r = t(function () {
    return C && "matchMedia" in window ? window.matchMedia(e) : {
      matches: !1
    };
  }, [e]),
      _n3 = n(r.matches),
      _n4 = _slicedToArray(_n3, 2),
      a = _n4[0],
      s = _n4[1];

  return O(function () {
    var e = function e(_e3) {
      s(_e3.matches);
    };

    return "addEventListener" in r && r.addEventListener("change", e), function () {
      "removeEventListener" in r && r.removeEventListener("change", e);
    };
  }, [r]), a;
},
    R = function R(_ref2) {
  var e = _ref2.reference,
      t = _ref2.popper,
      a = _ref2.children,
      _ref2$placement = _ref2.placement,
      s = _ref2$placement === void 0 ? "auto" : _ref2$placement,
      o = _ref2.modifiers,
      _ref2$strategy = _ref2.strategy,
      l = _ref2$strategy === void 0 ? "absolute" : _ref2$strategy,
      c = _ref2.onFirstUpdate;

  var _n5 = n(null),
      _n6 = _slicedToArray(_n5, 2),
      d = _n6[0],
      h = _n6[1],
      p = i({
    placement: s,
    modifiers: o || [],
    strategy: l,
    onFirstUpdate: c
  });

  return O(function () {
    var r;
    return e && t && (r = m(e, t, p.current), setTimeout(function () {
      h(r);
    }, 10)), function () {
      r && (r.destroy(), h(null));
    };
  }, [e, t]), r(function () {
    var e = {
      placement: s,
      modifiers: o || [],
      strategy: l,
      onFirstUpdate: c
    };
    u(e, p.current) || (p.current = e), d && d.setOptions(p.current);
  }, [s, o, l, c, d]), r(function () {
    d && d.update();
  }, [d, a]), d;
},
    z = function z(_ref3) {
  var e = _ref3.reference,
      r = _ref3.popper,
      n = _ref3.trigger,
      a = _ref3.isOpen,
      s = _ref3.hideDelay,
      o = _ref3.showDelay,
      c = _ref3.onRequestOpen,
      d = _ref3.onRequestClose;

  var u = i(),
      m = i(!1),
      h = i(!1),
      p = i(),
      f = i(),
      v = function v() {
    return window.clearTimeout(f.current);
  },
      b = l(function (e) {
    u.current = e, c && c(e), v();
  }, [c]),
      g = l(function (e) {
    d && d(e), window.clearTimeout(p.current);
  }, [d]),
      E = t(function () {
    if (C) return [r, e].reduce(function (e, t) {
      return t instanceof EventTarget && e.push(t), e;
    }, []);
  }, [r, e]);

  _(E, function () {
    if (r && n.includes("click")) return g("click.external");
  }), O(function () {
    var t = function t() {
      a ? g("click.reference") : b("click.reference");
    },
        i = function i(e) {
      "Escape" === e.key && g("escape");
    },
        l = function l(e) {
      "Enter" === e.key && (m.current = !0, t()), " " === e.key && (h.current = !0, e.preventDefault());
    },
        c = function c(e) {
      " " === e.key && h.current && (m.current = !0, h.current = !1, t());
    },
        d = function d() {
      m.current ? m.current = !1 : t();
    },
        E = function E() {
      return b("focus");
    },
        y = function y() {
      return b("focusin");
    },
        w = function w() {
      h.current = !1, g("blur");
    },
        N = function N(_ref4) {
      var e = _ref4.target;
      var t = [];

      var r = function r(e) {
        t = e.composedPath();
      };

      document.addEventListener("pointermove", r), p.current = window.setTimeout(function () {
        document.removeEventListener("pointermove", r), e && t.includes(e) && b("pointerenter");
      }, o);
    },
        C = function C() {
      f.current = window.setTimeout(function () {
        "pointerenter" === u.current && g("pointerleave");
      }, s);
    },
        _ = function _(e) {
      return !!e && (e instanceof window.HTMLElement || e instanceof window.SVGElement);
    };

    return document.addEventListener("keydown", i), n.includes("click") && _(e) && (e.addEventListener("click", d), e.addEventListener("keydown", l), e.addEventListener("keyup", c)), _(e) && (n.includes("focus") && e.addEventListener("focus", E), n.includes("focusin") && e.addEventListener("focusin", y), (n.includes("focus") || n.includes("focusin")) && e.addEventListener("blur", w), (n.includes("mouseenter") || n.includes("pointerenter")) && (e.addEventListener("pointerenter", N), e.addEventListener("pointerleave", C), r && r.addEventListener("pointerleave", C))), r && r.addEventListener("pointerenter", v), function () {
      v(), document.removeEventListener("keydown", i), _(e) && (e.removeEventListener("click", d), e.removeEventListener("keydown", l), e.removeEventListener("keyup", c), e.removeEventListener("focus", E), e.removeEventListener("focusin", y), e.removeEventListener("blur", w), e.removeEventListener("pointerenter", N), e.removeEventListener("pointerleave", C)), r && (r.removeEventListener("pointerenter", v), r.removeEventListener("pointerleave", C));
    };
  }, [g, s, a, r, e, b, o, n]);
},
    I = function I(_ref5) {
  var t = _ref5.autofocus,
      n = _ref5.container,
      a = _ref5.disabledItems,
      _ref5$initialIndex = _ref5.initialIndex,
      s = _ref5$initialIndex === void 0 ? 0 : _ref5$initialIndex,
      _ref5$nextKeys = _ref5.nextKeys,
      o = _ref5$nextKeys === void 0 ? ["ArrowDown", "ArrowRight"] : _ref5$nextKeys,
      _ref5$prevKeys = _ref5.prevKeys,
      i = _ref5$prevKeys === void 0 ? ["ArrowUp", "ArrowLeft"] : _ref5$prevKeys,
      c = _ref5.resetOnExit,
      d = _ref5.size,
      u = _ref5.wrap;

  var _ref6 = function (t) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref8$initialIndex = _ref8.initialIndex,
        r = _ref8$initialIndex === void 0 ? 0 : _ref8$initialIndex,
        _ref8$wrap = _ref8.wrap,
        n = _ref8$wrap === void 0 ? !1 : _ref8$wrap;

    var a = e.useCallback(function (e, r) {
      var a = e.current;

      switch (r.type) {
        case "INCREMENT":
          {
            var _r = a + 1;

            return n ? _r >= t && (_r = 0) : _r = Math.min(_r, t - 1), _objectSpread(_objectSpread({}, e), {}, {
              current: _r,
              direction: 1
            });
          }

        case "DECREMENT":
          {
            var _r2 = a - 1;

            return n ? _r2 < 0 && (_r2 = t - 1) : _r2 = Math.max(_r2, 0), _objectSpread(_objectSpread({}, e), {}, {
              current: _r2,
              direction: -1
            });
          }

        case "GOTO":
          {
            var _n7 = Math.max(Math.min(r.payload, t - 1), 0);

            return _objectSpread(_objectSpread({}, e), {}, {
              current: _n7,
              direction: Math.sign(_n7 - a)
            });
          }

        default:
          return e;
      }
    }, [t, n]);
    return e.useReducer(a, {
      current: r,
      direction: 0
    });
  }(d, {
    initialIndex: s,
    wrap: u
  }),
      _ref7 = _slicedToArray(_ref6, 2),
      m = _ref7[0],
      h = _ref7[1];

  r(function () {
    var e = m.current,
        t = m.direction;
    if (a && a.has(e)) switch (t) {
      case -1:
        h(u || 0 !== e ? {
          type: "DECREMENT"
        } : {
          type: "INCREMENT"
        });
        break;

      case 1:
        h(u || e !== d - 1 ? {
          type: "INCREMENT"
        } : {
          type: "DECREMENT"
        });
        break;

      default:
        a.size < d && h({
          type: "INCREMENT"
        });
    }
  }, [a, h, d, m, u]);
  var p = l(function (e) {
    d && ([].concat(_toConsumableArray(o), _toConsumableArray(i), ["Home", "End"]).includes(e.key) && e.preventDefault(), o.includes(e.key) && h({
      type: "INCREMENT"
    }), i.includes(e.key) && h({
      type: "DECREMENT"
    }), "End" === e.key && h({
      type: "GOTO",
      payload: d - 1
    }), "Home" === e.key && h({
      type: "GOTO",
      payload: 0
    }));
  }, [h, o, i, d]),
      f = l(function (_ref9) {
    var e = _ref9.relatedTarget;

    if (n) {
      if (e instanceof Node && n.contains(e)) return;
      c && h({
        type: "GOTO",
        payload: s
      });
    }
  }, [n, h, s, c]),
      v = l(function (e) {
    return function (r) {
      if (r) {
        var _a = n && n.contains(document.activeElement);

        m.current === e && (_a || t) && r.focus();
      }
    };
  }, [t, n, m]);
  return {
    state: m,
    dispatch: h,
    containerProps: {
      onKeyDown: p,
      onBlur: f
    },
    childProps: {
      createRef: v,
      tabIndex: function tabIndex(e) {
        return m.current === e ? 0 : -1;
      }
    }
  };
},
    B = function B() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _n8 = n(t),
      _n9 = _slicedToArray(_n8, 2),
      a = _n9[0],
      s = _n9[1];

  r(function () {
    if (!e && a.length > 1) throw new Error(B.SELECT_OVERLOAD);
  }, [e, a]);

  var o = function o(t) {
    s(e ? [].concat(_toConsumableArray(a), [t]) : [t]);
  },
      i = function i(e) {
    s(a.filter(function (t) {
      return t !== e;
    }));
  };

  return {
    selected: a,
    deselect: i,
    select: o,
    toggle: function toggle(t) {
      a.includes(t) ? e && i(t) : o(t);
    },
    formChangeHandler: function formChangeHandler(_ref10) {
      var e = _ref10.currentTarget,
          t = _ref10.target;

      var _ref11 = "value" in e && "checked" in e ? e : t,
          r = _ref11.checked,
          n = _ref11.value;

      if (void 0 === r) throw new Error('formChangeHandler is being attached to an invalid element. Attach it to an <input type="checkbox|radio"> or a <fieldset>.');
      r ? o(n) : i(n);
    }
  };
};

B.SELECT_OVERLOAD = "The number of selected values cannot exceed 1 when not multi-selectable.";

var P = a(void 0),
    D = function D() {
  var e = s(P);
  if (!e) throw new Error("No theme provided. To provide a theme, wrap your application in a <ThemeProvider>");
  return e;
},
    A = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    H = function H(e) {
  return function (t, r) {
    return !r || !r[e];
  };
},
    T = {
  badInput: function badInput(_ref12) {
    var e = _ref12.type;
    return T.typeMismatch({
      type: e
    });
  },
  patternMismatch: function patternMismatch() {
    return "";
  },
  rangeOverflow: function rangeOverflow(_ref13) {
    var e = _ref13.max;
    return "Please select a value that is no more than ".concat(e, ".");
  },
  rangeUnderflow: function rangeUnderflow(_ref14) {
    var e = _ref14.min;
    return "Please select a value that is no less than ".concat(e, ".");
  },
  stepMismatch: function stepMismatch() {
    return "";
  },
  tooLong: function tooLong(_ref15) {
    var e = _ref15.maxLength;
    return "Please use ".concat(e, " characters or fewer.");
  },
  tooShort: function tooShort(_ref16) {
    var e = _ref16.minLength,
        t = _ref16.type;

    switch (t) {
      case "password":
        return "Passwords must be at least ".concat(e, " characters long.");

      default:
        return "Please use at least ".concat(e, " characters.");
    }
  },
  typeMismatch: function typeMismatch(_ref17) {
    var e = _ref17.type;

    switch (e) {
      case "email":
        return "Please enter an email address.";

      case "tel":
        return "Please enter a phone number.";

      case "url":
        return "Please enter a URL.";

      case "number":
        return "Please enter a number.";

      default:
        return "";
    }
  },
  valueMissing: function valueMissing() {
    return "This field is required.";
  }
},
    V = function V(_ref18) {
  var e = _ref18.max,
      t = _ref18.maxLength,
      r = _ref18.min,
      n = _ref18.minLength,
      a = _ref18.required,
      s = _ref18.type;
  var o = [];

  switch (a && o.push({
    name: "valueMissing",
    test: H("valueMissing"),
    message: T.valueMissing({})
  }), t && t >= 0 && (o.push({
    name: "tooLong",
    test: H("tooLong"),
    message: T.tooLong({
      maxLength: t
    })
  }), o.push({
    name: "tooLong",
    test: function test(e) {
      return e.length <= t;
    },
    message: T.tooLong({
      maxLength: t
    })
  })), n && n >= 0 && o.push({
    name: "tooShort",
    test: H("tooShort"),
    message: function message() {
      return T.tooShort({
        minLength: n,
        type: s
      });
    }
  }), void 0 !== s && (o.push({
    name: "typeMismatch",
    test: "email" === s ? function (e) {
      return A.test(e);
    } : H("typeMismatch"),
    message: "Please enter an email address."
  }), o.push({
    test: H("badInput"),
    message: T.typeMismatch({
      type: s
    })
  })), s) {
    case "number":
    case "range":
      e && o.push({
        name: "rangeOverflow",
        test: H("rangeOverflow"),
        message: T.rangeOverflow({
          max: e
        })
      }), r && o.push({
        name: "rangeUnderflow",
        test: H("rangeUnderflow"),
        message: T.rangeUnderflow({
          min: r
        })
      });
  }

  return o;
},
    F = function F(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    return function (r) {
      if (!(e && e.length || t)) return [];
      var n = r.value,
          a = r.validity,
          s = n.toString(),
          o = new Set();
      return [].concat(_toConsumableArray(t ? V(r) : []), _toConsumableArray(e || [])).forEach(function (_ref19) {
        var e = _ref19.message,
            t = _ref19.test;
        var r = "function" == typeof e ? e(s) : e;
        t(s, a) || "" === e || o.add(r);
      }), Array.from(o);
    };
  }(t(function () {
    if (e) return Array.isArray(e) ? e : [e];
  }, [e]), r);
},
    q = {
  active: !1,
  activeClass: "active",
  type: "button"
},
    U = e.forwardRef(function (_ref20, u) {
  var _ref20$active = _ref20.active,
      t = _ref20$active === void 0 ? q.active : _ref20$active,
      _ref20$activeClass = _ref20.activeClass,
      r = _ref20$activeClass === void 0 ? q.activeClass : _ref20$activeClass,
      n = _ref20.onKeyDown,
      a = _ref20.onKeyUp,
      s = _ref20.onBlur,
      o = _ref20.className,
      i = _ref20.children,
      _ref20$type = _ref20.type,
      l = _ref20$type === void 0 ? q.type : _ref20$type,
      d = _objectWithoutProperties(_ref20, _excluded2);

  var _e$useState = e.useState(t),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      m = _e$useState2[0],
      h = _e$useState2[1];

  return e.useEffect(function () {
    h(t);
  }, [t]), e.createElement("button", y({
    className: c(r && _defineProperty({}, r, m), o),
    onKeyDown: function onKeyDown(e) {
      " " === e.key && h(!0), n && n(e);
    },
    onKeyUp: function onKeyUp(e) {
      " " === e.key && h(!1), a && a(e);
    },
    onBlur: function onBlur(e) {
      h(!1), s && s(e);
    },
    ref: u,
    type: l
  }, d), i);
});

U.defaultProps = q;
var K = "0 0 24 24",
    W = {
  account: {
    fullName: "Account",
    d: "M19.3 16.509a35.6 35.6 0 00-4.87-2.691v-2.763a2.013 2.013 0 00.7-1.6V7.273A2.99 2.99 0 0012 4a2.99 2.99 0 00-3.13 3.273v2.182a1.817 1.817 0 00.7 1.6v2.763c-1.391.655-4.452 2.473-4.87 2.691a1.33 1.33 0 00-.7 1.382v1.745a.336.336 0 00.348.364h15.3a.336.336 0 00.352-.364v-1.745a1.33 1.33 0 00-.7-1.382z",
    viewBox: K
  },
  "arrow-up": {
    fullName: "Arrow up",
    originalName: "arrow_upward",
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z",
    source: "https://material.io/resources/icons/?icon=arrow_upward&style=baseline",
    viewBox: K
  },
  "arrow-right": {
    fullName: "Arrow right",
    originalName: "arrow_forward",
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
    source: "https://material.io/resources/icons/?icon=arrow_forward&style=baseline",
    viewBox: K
  },
  "arrow-down": {
    fullName: "Arrow down",
    originalName: "arrow_downward",
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
    source: "https://material.io/resources/icons/?icon=arrow_downward&style=baseline",
    viewBox: K
  },
  "arrow-left": {
    fullName: "Arrow left",
    originalName: "arrow_back",
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
    source: "https://material.io/resources/icons/?icon=arrow_back&style=baseline",
    viewBox: K
  },
  calendar: {
    fullName: "Calendar",
    originalName: "event",
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z",
    source: "https://material.io/resources/icons/?icon=event&style=baseline",
    viewBox: K
  },
  cancel: {
    fullName: "Cancel",
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
    originalName: "cancel",
    source: "https://material.io/resources/icons/?icon=cancel&style=baseline",
    viewBox: K
  },
  "caret-up": {
    fullName: "Caret up",
    d: "M12 8.015l3.492 3.992 3.486 3.983H5.022l3.485-3.983L12 8.015z",
    viewBox: K
  },
  "caret-right": {
    fullName: "Caret right",
    d: "M15.985 12l-3.992 3.492-3.983 3.486V5.022l3.983 3.485L15.985 12z",
    viewBox: K
  },
  "caret-down": {
    fullName: "Caret down",
    d: "M12 15.985l-3.492-3.992L5.022 8.01h13.956l-3.485 3.983L12 15.985z",
    viewBox: K
  },
  "caret-left": {
    fullName: "Caret left",
    d: "M8.015 12l3.992-3.492 3.983-3.486v13.956l-3.983-3.485L8.015 12z",
    viewBox: K
  },
  check: {
    fullName: "Check",
    d: "M7.242 16.887l-4.24-4.245 2.12-2.121 4.243 4.245 9.513-9.516 2.124 2.121L9.363 19.007z",
    viewBox: K
  },
  "check-circle": {
    fullName: "Check circle",
    originalName: "check_circle",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
    source: "https://material.io/resources/icons/?icon=check_circle&style=baseline",
    viewBox: K
  },
  "chevron-up": {
    fullName: "Chevron up",
    originalName: "expand_less",
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
    source: "https://material.io/resources/icons/?icon=expand_less&style=baseline",
    viewBox: K
  },
  "chevron-right": {
    fullName: "Chevron right",
    originalName: "chevron_right",
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
    source: "https://material.io/resources/icons/?icon=chevron_right&style=baseline",
    viewBox: K
  },
  "chevron-down": {
    fullName: "Chevron down",
    originalName: "expand_more",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z",
    source: "https://material.io/resources/icons/?icon=expand_more&style=baseline",
    viewBox: K
  },
  "chevron-left": {
    fullName: "Chevron left",
    originalName: "chevron_left",
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
    source: "https://material.io/resources/icons/?icon=chevron_left&style=baseline",
    viewBox: K
  },
  close: {
    fullName: "Close",
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
    source: "https://material.io/resources/icons/?icon=close&style=baseline",
    viewBox: K
  },
  delete: {
    fullName: "Delete",
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
    source: "https://material.io/resources/icons/?icon=delete&style=baseline",
    viewBox: K
  },
  download: {
    fullName: "Download",
    originalName: "get_app",
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
    source: "https://material.io/resources/icons/?icon=get_app&style=baseline",
    viewBox: K
  },
  edit: {
    fullName: "Edit",
    originalName: "edit",
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z",
    source: "https://material.io/resources/icons/?icon=edit&style=baseline",
    viewBox: K
  },
  exclamation: {
    fullName: "Exclamation",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
    originalName: "error",
    source: "https://material.io/resources/icons/?icon=error&style=baseline",
    viewBox: K
  },
  flag: {
    fullName: "Flag",
    d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z",
    source: "https://material.io/resources/icons/?icon=flag&style=baseline",
    viewBox: K
  },
  heart: {
    fullName: "Heart",
    originalName: "favorite",
    d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z",
    source: "https://material.io/resources/icons/?icon=favorite&style=baseline",
    viewBox: K
  },
  "heart-outline": {
    fullName: "Heart outline",
    originalName: "favorite_border",
    d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z",
    source: "https://material.io/resources/icons/?icon=favorite_border&style=baseline",
    viewBox: K
  },
  info: {
    fullName: "Info",
    d: "M12 22a10 10 0 1110-10 10.016 10.016 0 01-10 10zm1.127-12.146a5.306 5.306 0 00-.678.049c-.279.035-.531.074-.77.119s-.459.088-.736.156a4.81 4.81 0 00-.557.174v.477l.859.2-.947 4.309-.006.025c-.033.178-.072.381-.1.559a3.757 3.757 0 00-.043.543.637.637 0 00.2.438 1 1 0 00.73.2 3.036 3.036 0 00.531-.049 4.068 4.068 0 00.547-.135 3.4 3.4 0 00.516-.2 3.323 3.323 0 00.428-.238v-.486h-.975l1.252-5.975-.25-.162zM12.889 6.1a1.237 1.237 0 00-.809.266.91.91 0 00-.318.736.869.869 0 00.318.709 1.208 1.208 0 00.809.266 1.242 1.242 0 00.844-.266.879.879 0 00.309-.709.91.91 0 00-.309-.736 1.287 1.287 0 00-.842-.266z",
    viewBox: K
  },
  launch: {
    fullName: "Launch",
    d: "M16 14h2v5a2.006 2.006 0 01-2 2H5a2.006 2.006 0 01-2-2V8a2.006 2.006 0 012-2h5v2H5v11h11zM14 3v2h3.586l-9.293 9.293 1.414 1.414L19 6.414V10h2V3z",
    viewBox: K
  },
  list: {
    fullName: "List",
    d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z",
    source: "https://material.io/resources/icons/?icon=list&style=baseline",
    viewBox: K
  },
  menu: {
    fullName: "Menu",
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
    source: "https://material.io/resources/icons/?icon=menu&style=baseline",
    viewBox: K
  },
  minus: {
    fullName: "Minus",
    d: "M2.875 10.375h18v3h-18z",
    viewBox: K
  },
  "minus-circle": {
    fullName: "Minus circle",
    originalName: "remove_circle",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z",
    source: "https://material.io/resources/icons/?icon=remove_circle&style=baseline",
    viewBox: K
  },
  "more-horizontal": {
    fullName: "More horizontal",
    originalName: "more_horiz",
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    source: "https://material.io/resources/icons/?icon=more_horiz&style=baseline",
    viewBox: K
  },
  "more-vertical": {
    fullName: "More vertical",
    originalName: "more_vert",
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    source: "https://material.io/resources/icons/?icon=more_vert&style=baseline",
    viewBox: K
  },
  plus: {
    fullName: "Plus",
    originalName: "add",
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    source: "https://material.io/resources/icons/?icon=add&style=baseline",
    viewBox: K
  },
  "plus-circle": {
    fullName: "Plus circle",
    originalName: "add_circle",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
    source: "https://material.io/resources/icons/?icon=add_circle&style=baseline",
    viewBox: K
  },
  print: {
    fullName: "Print",
    d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z",
    source: "https://material.io/resources/icons/?icon=print&style=baseline",
    viewBox: K
  },
  save: {
    fullName: "Save",
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z",
    source: "https://material.io/resources/icons/?icon=save&style=baseline",
    viewBox: K
  },
  search: {
    fullName: "Search",
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    source: "https://material.io/resources/icons/?icon=search&style=baseline",
    viewBox: K
  },
  settings: {
    fullName: "Settings",
    d: "M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z",
    source: "https://material.io/resources/icons/?icon=settings&style=baseline",
    viewBox: K
  },
  star: {
    fullName: "Star",
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
    source: "https://material.io/resources/icons/?icon=star&style=baseline",
    viewBox: K
  },
  "star-outline": {
    fullName: "Star outline",
    originalName: "star_border",
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z",
    source: "https://material.io/resources/icons/?icon=star_border&style=baseline",
    viewBox: K
  },
  "subdirectory-left": {
    fullName: "Subdirectory left",
    originalName: "subdirectory_arrow_left",
    d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z",
    source: "https://material.io/resources/icons/?icon=subdirectory_arrow_left&style=baseline",
    viewBox: K
  },
  "subdirectory-right": {
    fullName: "Subdirectory right",
    originalName: "subdirectory_arrow_right",
    d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z",
    source: "https://material.io/resources/icons/?icon=subdirectory_arrow_right&style=baseline",
    viewBox: K
  },
  warning: {
    fullName: "Warning",
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    source: "https://material.io/resources/icons/?icon=warning&style=baseline",
    viewBox: K
  }
},
    j = {};
Object.keys(W).forEach(function (e) {
  var t = W[e].fullName;
  t && (j[t] = e);
});

var G = function G(e) {
  if (e) return W[e];
},
    Z = e.forwardRef(function (_ref22, a) {
  var t = _ref22.source,
      r = _ref22.children,
      n = _objectWithoutProperties(_ref22, _excluded3);

  return e.createElement("svg", y({
    ref: a,
    xmlns: "http://www.w3.org/2000/svg",
    "data-source": t
  }, n), r);
}),
    Y = function Y(e) {
  return {
    name: e,
    enabled: !1,
    options: {}
  };
},
    J = Y("arrow"),
    Q = Y("flip"),
    X = Y("offset"),
    ee = Y("preventOverflow"),
    te = {
  name: "matchWidth",
  enabled: !1,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: function fn(_ref23) {
    var e = _ref23.state;
    e.styles.popper.width = "".concat(e.rects.reference.width, "px");
  },
  effect: function effect(_ref24) {
    var e = _ref24.state;
    return function () {
      e.elements.popper.style.width = "".concat(e.elements.reference.offsetWidth, "px");
    };
  }
},
    re = e.forwardRef(function (_ref25, P) {
  var t = _ref25.isOpen,
      r = _ref25.reference,
      n = _ref25.transition,
      a = _ref25.addEndListener,
      s = _ref25.onEnter,
      o = _ref25.onEntering,
      i = _ref25.onEntered,
      l = _ref25.onExit,
      c = _ref25.onExiting,
      d = _ref25.onExited,
      u = _ref25.timeout,
      _ref25$placement = _ref25.placement,
      m = _ref25$placement === void 0 ? "auto" : _ref25$placement,
      h = _ref25.modifiers,
      _ref25$strategy = _ref25.strategy,
      v = _ref25$strategy === void 0 ? "absolute" : _ref25$strategy,
      b = _ref25.onFirstUpdate,
      _ref25$enableArrow = _ref25.enableArrow,
      g = _ref25$enableArrow === void 0 ? !1 : _ref25$enableArrow,
      E = _ref25.arrowElement,
      _ref25$arrowPadding = _ref25.arrowPadding,
      w = _ref25$arrowPadding === void 0 ? 0 : _ref25$arrowPadding,
      _ref25$enableFlip = _ref25.enableFlip,
      N = _ref25$enableFlip === void 0 ? !0 : _ref25$enableFlip,
      C = _ref25.flipOptions,
      _ = _ref25.offset,
      x = _ref25.distance,
      _ref25$enablePreventO = _ref25.enablePreventOverflow,
      M = _ref25$enablePreventO === void 0 ? !0 : _ref25$enablePreventO,
      _ref25$boundary = _ref25.boundary,
      L = _ref25$boundary === void 0 ? "clippingParents" : _ref25$boundary,
      $ = _ref25.preventOverflowOptions,
      _ref25$matchWidth = _ref25.matchWidth,
      S = _ref25$matchWidth === void 0 ? !1 : _ref25$matchWidth,
      R = _ref25.children,
      _ref25$className = _ref25.className,
      z = _ref25$className === void 0 ? "nds-popper" : _ref25$className,
      I = _ref25.style,
      B = _objectWithoutProperties(_ref25, _excluded4);

  var _k = k(P),
      _k2 = _slicedToArray(_k, 2),
      D = _k2[0],
      A = _k2[1],
      _e$useState3 = e.useState(null),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      H = _e$useState4[0],
      T = _e$useState4[1],
      _e$useState5 = e.useState(),
      _e$useState6 = _slicedToArray(_e$useState5, 2),
      V = _e$useState6[0],
      F = _e$useState6[1],
      q = e.useMemo(function () {
    return _ ? "function" == typeof _ ? D && r instanceof Element ? _({
      popper: D.getBoundingClientRect(),
      reference: r.getBoundingClientRect(),
      placement: m
    })[1] : 0 : _[1] : void 0 !== x ? x : null != V ? V : 0;
  }, [x, V, _, m, D, r]);

  O(function () {
    if (D) {
      var _e4 = parseFloat(window.getComputedStyle(D).getPropertyValue("--nds-popper-distance"));

      0 !== q || Number.isNaN(_e4) || F(_e4), _e4 !== q && D.style.setProperty("--nds-popper-distance", "".concat(q, "px"));
    }
  }, [q, D]);

  var U = e.useMemo(function () {
    return [_objectSpread(_objectSpread({}, J), {}, {
      enabled: g,
      options: {
        element: E || H,
        padding: w
      }
    }), _objectSpread(_objectSpread({}, Q), {}, {
      enabled: N,
      options: C
    }), _objectSpread(_objectSpread({}, X), {}, {
      enabled: !0,
      options: {
        offset: null != _ ? _ : [0, q]
      }
    }), _objectSpread(_objectSpread({}, ee), {}, {
      enabled: M,
      options: null != $ ? $ : {
        boundary: L
      }
    }), _objectSpread(_objectSpread({}, te), {}, {
      enabled: S
    })].concat(_toConsumableArray(h || []));
  }, [H, w, E, L, q, g, N, M, C, S, h, _, $]),
      _p = p(r, D, {
    placement: m,
    strategy: v,
    onFirstUpdate: b,
    modifiers: U
  }),
      K = _p.styles,
      W = _p.attributes,
      j = e.useMemo(function () {
    return a ? {
      addEndListener: a
    } : u ? {
      timeout: u
    } : {
      addEndListener: function addEndListener(e, t) {
        parseFloat(window.getComputedStyle(e).transitionDuration) > 0 ? e.addEventListener("transitionend", t, !1) : t();
      }
    };
  }, [a, u]);

  return e.createElement(f, y({
    classNames: n,
    onEnter: s,
    onEntering: o,
    onEntered: i,
    onExit: l,
    onExiting: c,
    onExited: d
  }, j, {
    in: t,
    mountOnEnter: !0,
    unmountOnExit: !0
  }), e.createElement("div", y({}, B, {
    className: z,
    style: _objectSpread(_objectSpread({}, I), K.popper)
  }, W.popper, {
    ref: A
  }), R, !E && g && e.createElement("div", {
    "data-popper-arrow": !0,
    style: K.arrow,
    ref: T
  })));
}),
    ne = e.forwardRef(function (_ref26, x) {
  var t = _ref26.isOpen,
      _ref26$transition = _ref26.transition,
      r = _ref26$transition === void 0 ? "fade" : _ref26$transition,
      n = _ref26.reference,
      a = _ref26.arrowElement,
      s = _ref26.distance,
      o = _ref26.boundary,
      _ref26$placement = _ref26.placement,
      i = _ref26$placement === void 0 ? "top" : _ref26$placement,
      l = _ref26.modifiers,
      d = _ref26.strategy,
      u = _ref26.onFirstUpdate,
      _ref26$hideDelay = _ref26.hideDelay,
      m = _ref26$hideDelay === void 0 ? 200 : _ref26$hideDelay,
      _ref26$showDelay = _ref26.showDelay,
      p = _ref26$showDelay === void 0 ? 400 : _ref26$showDelay,
      _ref26$baseName = _ref26.baseName,
      f = _ref26$baseName === void 0 ? "nds-tooltip" : _ref26$baseName,
      _ref26$bodyClass = _ref26.bodyClass,
      v = _ref26$bodyClass === void 0 ? "".concat(f, "__body") : _ref26$bodyClass,
      b = _ref26.contentClass,
      g = _ref26.arrowClass,
      _ref26$asLabel = _ref26.asLabel,
      E = _ref26$asLabel === void 0 ? !1 : _ref26$asLabel,
      _ref26$trigger = _ref26.trigger,
      w = _ref26$trigger === void 0 ? "focus pointerenter" : _ref26$trigger,
      N = _ref26.children,
      C = _ref26.className,
      _ = _objectWithoutProperties(_ref26, _excluded5);

  var _k3 = k(x),
      _k4 = _slicedToArray(_k3, 2),
      M = _k4[0],
      L = _k4[1],
      $ = e.useRef(h("".concat(f, "-"))),
      _e$useState7 = e.useState(t || !1),
      _e$useState8 = _slicedToArray(_e$useState7, 2),
      O = _e$useState8[0],
      S = _e$useState8[1];

  return e.useEffect(function () {
    void 0 !== t && S(t);
  }, [t]), z({
    reference: n,
    popper: M,
    trigger: w,
    isOpen: O,
    hideDelay: m,
    showDelay: p,
    onRequestClose: function onRequestClose() {
      return !w.includes("manual") && S(!1);
    },
    onRequestOpen: function onRequestOpen() {
      return !w.includes("manual") && S(!0);
    }
  }), e.useEffect(function () {
    n && n instanceof Element && n.setAttribute(E ? "aria-labelledby" : "aria-describedby", $.current);
  }, [E, n]), N ? e.createElement(e.Fragment, null, e.createElement(re, y({
    role: "tooltip",
    "aria-hidden": "true",
    className: c(f, C),
    isOpen: O,
    transition: r,
    reference: n,
    arrowElement: a || g,
    distance: s,
    boundary: o,
    placement: i,
    modifiers: l,
    strategy: d,
    onFirstUpdate: u,
    enableArrow: !0,
    ref: L
  }, _), e.createElement("div", {
    className: b || v
  }, N)), e.createElement("div", {
    hidden: !0,
    "aria-hidden": "true",
    id: $.current
  }, N)) : null;
}),
    ae = e.forwardRef(function (_ref27, p) {
  var _ref27$baseName = _ref27.baseName,
      t = _ref27$baseName === void 0 ? "nds-icon" : _ref27$baseName,
      r = _ref27.className,
      _ref27$color = _ref27.color,
      n = _ref27$color === void 0 ? "currentColor" : _ref27$color,
      a = _ref27.icon,
      _ref27$size = _ref27.size,
      s = _ref27$size === void 0 ? "1.25em" : _ref27$size,
      o = _ref27.variant,
      _ref27$warnOnClick = _ref27.warnOnClick,
      i = _ref27$warnOnClick === void 0 ? !0 : _ref27$warnOnClick,
      l = _ref27.tooltipProps,
      d = _ref27.onClick,
      u = _ref27["aria-label"],
      m = _ref27.children,
      h = _objectWithoutProperties(_ref27, _excluded6);

  d && i && console.warn("You've attached a click listener to an icon, which will be inaccessible to many users. Use the Button or IconButton component instead.");

  var _k5 = k(p),
      _k6 = _slicedToArray(_k5, 2),
      f = _k6[0],
      v = _k6[1],
      b = e.useMemo(function () {
    if (!m) return !u || void 0;
  }, [u, m]),
      g = a || G(o),
      E = e.useMemo(function () {
    return m ? e.createElement(ne, y({
      asLabel: !0,
      reference: f
    }, l), m) : null;
  }, [m, l, f]);

  if (!g) return null;
  var w = g.d,
      N = g.source,
      _g$viewBox = g.viewBox,
      C = _g$viewBox === void 0 ? K : _g$viewBox,
      _ = g.children,
      x = g.label,
      M = c(t, _defineProperty({}, "".concat(t, "--").concat(o), o), r);
  return e.createElement(e.Fragment, null, e.createElement(Z, y({
    ref: v,
    source: N,
    viewBox: C,
    height: s,
    width: s,
    style: {
      minWidth: s
    },
    className: M,
    "aria-label": u || x,
    "aria-hidden": b,
    focusable: "false",
    tabIndex: m ? 0 : void 0,
    role: "img",
    fill: n
  }, h), w && e.createElement("path", {
    d: w,
    "aria-hidden": "true"
  }), _), E);
}),
    se = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
},
    oe = {
  removeAfter: 450,
  updateAfter: 50,
  "aria-live": "assertive"
},
    ie = function ie(_ref28) {
  var _ref28$removeAfter = _ref28.removeAfter,
      t = _ref28$removeAfter === void 0 ? oe.removeAfter : _ref28$removeAfter,
      _ref28$updateAfter = _ref28.updateAfter,
      r = _ref28$updateAfter === void 0 ? oe.updateAfter : _ref28$updateAfter,
      n = _ref28.visible,
      a = _ref28["aria-atomic"],
      _ref28$ariaLive = _ref28["aria-live"],
      s = _ref28$ariaLive === void 0 ? oe["aria-live"] : _ref28$ariaLive,
      o = _ref28["aria-relevant"],
      i = _ref28.children,
      l = _ref28.className,
      c = _ref28.id,
      d = _ref28.role;

  var _e$useState9 = e.useState(""),
      _e$useState10 = _slicedToArray(_e$useState9, 2),
      u = _e$useState10[0],
      m = _e$useState10[1],
      _e$useState11 = e.useState(!1),
      _e$useState12 = _slicedToArray(_e$useState11, 2),
      h = _e$useState12[0],
      p = _e$useState12[1],
      f = e.useRef(i),
      v = e.useRef(),
      g = function g() {
    m(""), p(!1);
  },
      E = e.useCallback(function () {
    m(i), t && (v.current = window.setTimeout(g, t));
  }, [i, t]);

  e.useEffect(function () {
    h && window.setTimeout(E, r);
  }, [h, E, r]), e.useEffect(function () {
    i && f.current !== i && (window.clearTimeout(v.current), f.current = i, p(!0));
  }, [i]);
  var y = e.useMemo(function () {
    return e.createElement("div", {
      "aria-atomic": a,
      "aria-live": s,
      "aria-relevant": o,
      className: l,
      id: c,
      role: d,
      style: n ? void 0 : se
    }, u);
  }, [a, s, o, l, c, u, d, n]);
  return "undefined" == typeof document ? null : b(h ? y : null, document.body);
};

ie.defaultProps = oe;

var le = function le(t, r) {
  var _e$useState13 = e.useState(""),
      _e$useState14 = _slicedToArray(_e$useState13, 2),
      n = _e$useState14[0],
      a = _e$useState14[1],
      s = e.useRef(r);

  return e.useEffect(function () {
    t && document.activeElement === t && (u(s.current, r) || (s.current = r, a(r)));
  }, [r, t]), n;
},
    ce = e.forwardRef(function (_ref29, v) {
  var _c3;

  var _ref29$baseName = _ref29.baseName,
      t = _ref29$baseName === void 0 ? "nds-button" : _ref29$baseName,
      r = _ref29.variant,
      n = _ref29.icon,
      a = _ref29.iconRight,
      s = _ref29.iconOnly,
      o = _ref29.color,
      i = _ref29.tooltipProps,
      _ref29$iconClass = _ref29.iconClass,
      l = _ref29$iconClass === void 0 ? "".concat(t, "__icon") : _ref29$iconClass,
      _ref29$textClass = _ref29.textClass,
      d = _ref29$textClass === void 0 ? "".concat(t, "__text") : _ref29$textClass,
      u = _ref29.className,
      m = _ref29.children,
      h = _ref29["aria-label"],
      p = _ref29["aria-labelledby"],
      f = _objectWithoutProperties(_ref29, _excluded7);

  if (!e.Children.count(m) && !h && !p) throw new Error("Button components must always have a valid accessible name. This means that your button is missing `children` or an ARIA name. See https://w3c.github.io/aria-practices/#names_and_descriptions.");

  var _k7 = k(v),
      _k8 = _slicedToArray(_k7, 2),
      b = _k8[0],
      g = _k8[1],
      E = le(b, m),
      w = e.useMemo(function () {
    if (!n) return null;
    var t = {
      className: l
    },
        r = "string" == typeof n ? _objectSpread(_objectSpread({}, t), {}, {
      variant: n
    }) : _objectSpread(_objectSpread({}, t), {}, {
      icon: n
    });
    return e.createElement(ae, r);
  }, [n, l]),
      N = e.useMemo(function () {
    return n && s ? null : e.isValidElement(m) ? m : e.createElement("span", {
      className: d,
      children: m
    });
  }, [m, n, s, d]),
      C = c((_c3 = {}, _defineProperty(_c3, "".concat(t, "--solid"), "solid" === r), _defineProperty(_c3, "".concat(t, "--outline"), "outline" === r), _defineProperty(_c3, "".concat(t, "--ghost"), "ghost" === r), _defineProperty(_c3, "".concat(t, "--icon-only"), n && s), _defineProperty(_c3, "".concat(t, "--").concat(o), void 0 !== o), _c3), t, u);

  return e.createElement(e.Fragment, null, e.createElement(U, y({
    className: C,
    ref: g,
    "aria-label": h,
    "aria-labelledby": p
  }, f), a ? null : w, N, a ? w : null), s && e.createElement(ne, y({
    asLabel: !0,
    reference: b
  }, i), m), e.createElement(ie, null, E));
}),
    de = e.forwardRef(function (_ref30, a) {
  var _ref30$variant = _ref30.variant,
      t = _ref30$variant === void 0 ? "ghost" : _ref30$variant,
      r = _ref30.children,
      n = _objectWithoutProperties(_ref30, _excluded8);

  return e.createElement(ce, y({
    iconOnly: !0,
    variant: t,
    ref: a
  }, n), r);
}),
    ue = function ue(_ref31) {
  var _c4;

  var t = _ref31.title,
      r = _ref31.icon,
      _ref31$dismissible = _ref31.dismissible,
      n = _ref31$dismissible === void 0 ? !1 : _ref31$dismissible,
      a = _ref31.tag,
      s = _ref31.children,
      o = _ref31.className,
      _ref31$baseName = _ref31.baseName,
      i = _ref31$baseName === void 0 ? "nds-callout" : _ref31$baseName,
      _ref31$iconClass = _ref31.iconClass,
      l = _ref31$iconClass === void 0 ? "".concat(i, "__icon") : _ref31$iconClass,
      _ref31$headerClass = _ref31.headerClass,
      d = _ref31$headerClass === void 0 ? "".concat(i, "__header") : _ref31$headerClass,
      _ref31$titleClass = _ref31.titleClass,
      u = _ref31$titleClass === void 0 ? "".concat(i, "__title") : _ref31$titleClass,
      _ref31$dismissClass = _ref31.dismissClass,
      m = _ref31$dismissClass === void 0 ? "".concat(i, "__dismiss") : _ref31$dismissClass,
      _ref31$bodyClass = _ref31.bodyClass,
      h = _ref31$bodyClass === void 0 ? "".concat(i, "__body") : _ref31$bodyClass,
      p = _ref31.border,
      f = _ref31.color,
      v = _ref31.onDismiss,
      b = _objectWithoutProperties(_ref31, _excluded9);

  var _e$useState15 = e.useState(!1),
      _e$useState16 = _slicedToArray(_e$useState15, 2),
      E = _e$useState16[0],
      w = _e$useState16[1],
      N = e.useRef(g("callout-title-")),
      C = t ? N.current : void 0,
      _ = e.useMemo(function () {
    return "string" == typeof r ? {
      variant: r
    } : {
      icon: r
    };
  }, [r]),
      k = c(o, i, (_c4 = {}, _defineProperty(_c4, "".concat(i, "--").concat(f), void 0 !== f), _defineProperty(_c4, "".concat(i, "--no-title"), !t), _c4)),
      x = e.useMemo(function () {
    return a || (t ? "aside" : "div");
  }, [a, t]);

  return E ? null : e.createElement(x, y({
    className: k,
    "data-border": p,
    "aria-labelledby": C
  }, b), t && e.createElement("header", {
    className: d
  }, r && e.createElement("span", {
    className: l
  }, e.createElement(ae, y({
    size: "100%"
  }, _))), e.createElement("div", {
    className: u,
    id: C
  }, t)), n && e.createElement(ce, {
    icon: "close",
    iconOnly: !0,
    onClick: function onClick() {
      w(!0), v && v();
    },
    className: m
  }, "Dismiss"), e.createElement("div", {
    className: h
  }, s));
},
    me = function me(_ref32) {
  var t = _ref32.children,
      r = _objectWithoutProperties(_ref32, _excluded10);

  return e.createElement(ue, y({
    border: "left",
    color: "error",
    icon: "exclamation",
    title: "Error"
  }, r), t);
},
    he = function he(_ref33) {
  var t = _ref33.children,
      r = _objectWithoutProperties(_ref33, _excluded11);

  return e.createElement(ue, y({
    border: "left",
    color: "success",
    icon: "check-circle",
    title: "Success"
  }, r), t);
},
    pe = function pe(_ref34) {
  var t = _ref34.children,
      r = _objectWithoutProperties(_ref34, _excluded12);

  return e.createElement(ue, y({
    border: "left",
    color: "warning",
    icon: "warning",
    title: "Warning"
  }, r), t);
},
    fe = function fe(_ref35) {
  var t = _ref35.label,
      r = _ref35.labelTag,
      n = _ref35.indicator,
      a = _ref35.description,
      _ref35$baseName = _ref35.baseName,
      s = _ref35$baseName === void 0 ? "nds-field" : _ref35$baseName,
      _ref35$labelClass = _ref35.labelClass,
      o = _ref35$labelClass === void 0 ? "".concat(s, "__label") : _ref35$labelClass,
      _ref35$indicatorClass = _ref35.indicatorClass,
      i = _ref35$indicatorClass === void 0 ? "".concat(s, "__indicator") : _ref35$indicatorClass,
      _ref35$descriptionCla = _ref35.descriptionClass,
      l = _ref35$descriptionCla === void 0 ? "".concat(s, "__desc") : _ref35$descriptionCla,
      d = _ref35.labelId,
      u = _ref35.descriptionId,
      m = _ref35.children,
      h = _ref35.className,
      p = _ref35.htmlFor,
      f = _ref35.id;
  var v = e.useMemo(function () {
    return n ? e.createElement(e.Fragment, null, " ", e.createElement("span", {
      className: i
    }, "(", n, ")")) : null;
  }, [n, i]),
      b = e.useMemo(function () {
    return e.createElement(p ? "label" : r || "div", {
      className: o,
      htmlFor: p,
      id: d,
      children: e.createElement(e.Fragment, null, t, v)
    });
  }, [t, o, p, d, v, r]),
      g = e.useMemo(function () {
    return "legend" === r || a ? e.createElement("div", {
      className: l,
      id: u
    }, a) : null;
  }, [r, a, l, u]);
  return "legend" === r ? e.createElement(e.Fragment, null, b, g, m) : e.createElement("div", {
    className: c("".concat(s, "__info"), h),
    id: f
  }, b, g, m);
},
    ve = function ve(_ref36) {
  var t = _ref36.errors,
      _ref36$liveErrors = _ref36.liveErrors,
      r = _ref36$liveErrors === void 0 ? !0 : _ref36$liveErrors,
      _ref36$baseName = _ref36.baseName,
      n = _ref36$baseName === void 0 ? "nds-field" : _ref36$baseName,
      _ref36$errorsClass = _ref36.errorsClass,
      a = _ref36$errorsClass === void 0 ? "".concat(n, "__errors") : _ref36$errorsClass,
      s = _ref36.errorsId,
      o = _ref36.children,
      _ref36$className = _ref36.className,
      i = _ref36$className === void 0 ? "".concat(n, "__feedback") : _ref36$className,
      l = _ref36.id;
  var c = e.useMemo(function () {
    return t && t.length ? e.createElement("ul", {
      className: a,
      id: s,
      "aria-label": "Errors",
      "aria-live": r ? "assertive" : void 0,
      "aria-atomic": r ? "true" : void 0
    }, t.map(function (t) {
      return e.createElement("li", {
        key: t
      }, t);
    })) : null;
  }, [t, a, s, r]);
  return e.createElement("div", {
    id: l,
    className: i
  }, c, o);
},
    be = function be(_ref37) {
  var t = _ref37.children,
      _ref37$baseName = _ref37.baseName,
      r = _ref37$baseName === void 0 ? "nds-field" : _ref37$baseName,
      _ref37$className = _ref37.className,
      n = _ref37$className === void 0 ? "".concat(r, "__addon") : _ref37$className;
  return e.createElement("span", {
    className: n
  }, t);
},
    ge = {
  validateOnDOMChange: !0
},
    Ee = e.forwardRef(function (_ref38, u) {
  var t = _ref38.errors,
      r = _ref38.validateOnChange,
      _ref38$validateOnDOMC = _ref38.validateOnDOMChange,
      n = _ref38$validateOnDOMC === void 0 ? ge.validateOnDOMChange : _ref38$validateOnDOMC,
      a = _ref38.validators,
      s = _ref38.maxLength,
      _ref38$maxLengthRestr = _ref38.maxLengthRestrictsInput,
      o = _ref38$maxLengthRestr === void 0 ? !1 : _ref38$maxLengthRestr,
      i = _ref38.onInput,
      l = _ref38.onDOMChange,
      c = _ref38.onValidate,
      d = _objectWithoutProperties(_ref38, _excluded13);

  var _k9 = k(u),
      _k10 = _slicedToArray(_k9, 2),
      m = _k10[0],
      h = _k10[1],
      _e$useState17 = e.useState(t),
      _e$useState18 = _slicedToArray(_e$useState17, 2),
      p = _e$useState18[0],
      f = _e$useState18[1];

  e.useEffect(function () {
    return f(t);
  }, [t]);
  var v = F(a),
      b = e.useCallback(function (_ref39) {
    var e = _ref39.max,
        r = _ref39.maxLength,
        n = _ref39.min,
        a = _ref39.minLength,
        o = _ref39.pattern,
        i = _ref39.required,
        l = _ref39.step,
        d = _ref39.type,
        u = _ref39.value,
        m = _ref39.validity;
    var h = v({
      max: e,
      maxLength: s || r,
      min: n,
      minLength: a,
      pattern: o,
      required: i,
      step: l,
      type: d,
      value: u,
      validity: m
    });
    c && c(h), t || f(h);
  }, [v, c, t, s]),
      g = e.useCallback(function (e) {
    l && l(e), n && b(e.target);
  }, [l, n, b]);
  return e.useEffect(function () {
    if (m && m.willValidate) {
      var _e5 = p && p.length ? p.join("\n") : "";

      m.setCustomValidity(_e5);
    }
  }, [m, p]), O(function () {
    return m && g && m.addEventListener("change", g), function () {
      m && g && m.removeEventListener("change", g);
    };
  }, [m, g]), e.createElement("input", y({
    ref: h,
    onInput: function onInput(e) {
      i && i(e), r && b(e.currentTarget);
    },
    maxLength: o ? s : void 0
  }, d));
});

Ee.defaultProps = ge;

var ye = e.forwardRef(function (_ref40, I) {
  var _ref40$type = _ref40.type,
      t = _ref40$type === void 0 ? "radio" : _ref40$type,
      _ref40$checked = _ref40.checked,
      r = _ref40$checked === void 0 ? !1 : _ref40$checked,
      n = _ref40.indeterminate,
      a = _ref40.optionalIndicator,
      s = _ref40.requiredIndicator,
      o = _ref40.validators,
      i = _ref40.description,
      l = _ref40.thumbnail,
      d = _ref40.errors,
      u = _ref40.children,
      _ref40$baseName = _ref40.baseName,
      m = _ref40$baseName === void 0 ? "nds-field" : _ref40$baseName,
      _ref40$className = _ref40.className,
      p = _ref40$className === void 0 ? c("".concat(m, "__group"), "".concat(m, "__group--choice")) : _ref40$className,
      _ref40$controlClass = _ref40.controlClass,
      f = _ref40$controlClass === void 0 ? c("".concat(m, "__control"), "".concat(m, "__control--").concat(t)) : _ref40$controlClass,
      v = _ref40.descriptionClass,
      _ref40$inputClass = _ref40.inputClass,
      b = _ref40$inputClass === void 0 ? c("".concat(m, "__input"), "".concat(m, "__input--").concat(t)) : _ref40$inputClass,
      _ref40$thumbnailClass = _ref40.thumbnailClass,
      g = _ref40$thumbnailClass === void 0 ? "".concat(m, "__thumbnail") : _ref40$thumbnailClass,
      _ref40$checkedClass = _ref40.checkedClass,
      E = _ref40$checkedClass === void 0 ? "".concat(m, "--checked") : _ref40$checkedClass,
      w = _ref40.labelClass,
      N = _ref40.errorsClass,
      C = _ref40.id,
      _ = _ref40.labelId,
      x = _ref40.descriptionId,
      M = _ref40.errorsId,
      L = _ref40.required,
      $ = _ref40.value,
      O = _ref40.onChange,
      S = _ref40.onDOMChange,
      R = _ref40.onValidate,
      z = _objectWithoutProperties(_ref40, _excluded14);

  var _k11 = k(I),
      _k12 = _slicedToArray(_k11, 2),
      B = _k12[0],
      P = _k12[1],
      _e$useState19 = e.useState(r),
      _e$useState20 = _slicedToArray(_e$useState19, 2),
      D = _e$useState20[0],
      A = _e$useState20[1],
      _e$useState21 = e.useState(n),
      _e$useState22 = _slicedToArray(_e$useState21, 2),
      H = _e$useState22[0],
      T = _e$useState22[1],
      _e$useState23 = e.useState(d),
      _e$useState24 = _slicedToArray(_e$useState23, 2),
      V = _e$useState24[0],
      F = _e$useState24[1],
      q = e.useRef(C || h("".concat(m, "-"))),
      U = e.useRef(_ || "".concat(q.current, "-label")),
      K = e.useRef(x || "".concat(q.current, "-desc")),
      W = e.useRef(M || "".concat(q.current, "-err")),
      j = e.useRef("".concat(q.current, "-input"));

  e.useEffect(function () {
    return F(d);
  }, [d]), e.useEffect(function () {
    return A(r);
  }, [r]), e.useEffect(function () {
    return T(n);
  }, [n]);
  var G = e.useMemo(function () {
    return s && L ? "required" : a && !L ? "optional" : null;
  }, [s, a, L]),
      Z = e.useMemo(function () {
    return e.createElement("label", {
      className: f,
      htmlFor: j.current,
      "aria-hidden": "true"
    }, "checkbox" === t && e.createElement(ae, {
      variant: H ? "minus" : "check",
      stroke: "currentColor"
    }));
  }, [f, H, t]),
      Y = e.useMemo(function () {
    return l ? e.createElement("label", {
      className: g,
      htmlFor: j.current,
      role: "none"
    }, l) : null;
  }, [l, g]),
      J = e.useMemo(function () {
    return "checkbox" === t && V && 0 !== V.length ? e.createElement(ve, {
      errors: V,
      errorsClass: N,
      errorsId: W.current
    }) : null;
  }, [t, V, N]),
      Q = e.useMemo(function () {
    return Boolean(!V || 0 === V.length);
  }, [V]);
  return e.useEffect(function () {
    B && "checkbox" === t && void 0 !== H && (B.indeterminate = H);
  }, [B, t, H]), e.createElement("div", {
    className: c(p, _defineProperty({}, E, D))
  }, e.createElement(Ee, y({
    type: t,
    checked: D,
    ref: P,
    id: j.current,
    className: b,
    errors: V,
    validators: o,
    "aria-labelledby": U.current,
    "aria-describedby": i ? K.current : void 0,
    "aria-invalid": !Q,
    "aria-errormessage": Q ? void 0 : W.current,
    onChange: function onChange(e) {
      O ? O(e) : (A(e.currentTarget.checked), T(!1));
    },
    onDOMChange: S,
    onValidate: function onValidate(e) {
      R && R(e), d || F(e);
    },
    required: L,
    value: $
  }, z)), Z, Y, e.createElement(fe, {
    indicator: G,
    htmlFor: j.current,
    label: u || $,
    labelClass: w,
    labelId: U.current,
    description: i,
    descriptionClass: v,
    descriptionId: K.current
  }, J));
}),
    we = function we(_ref41) {
  var t = _ref41.choices,
      r = _ref41.selected,
      n = _ref41.multiple,
      a = _objectWithoutProperties(_ref41, _excluded15);

  var s = e.useMemo(function () {
    return Array.isArray(r) ? r : void 0 !== r ? [r] : [];
  }, [r]),
      o = e.useMemo(function () {
    return t.map(function (t, r) {
      var o, i;
      "object" == typeof t ? (o = (t.value || t.children || "").toString(), i = _objectSpread(_objectSpread(_objectSpread({}, t), a), {}, {
        value: o
      })) : (o = t, i = _objectSpread({
        value: o,
        children: o
      }, a));
      var l = void 0 !== o ? o.toString() : "choice-".concat(r),
          c = s.includes(o);
      return e.createElement(ye, y({
        key: l
      }, i, {
        checked: c,
        type: n ? "checkbox" : "radio"
      }));
    });
  }, [t, a, s, n]);
  return e.createElement(e.Fragment, null, o);
},
    Ne = e.forwardRef(function (_ref42, k) {
  var t = _ref42.multiple,
      r = _ref42.required,
      n = _ref42.optionalIndicator,
      a = _ref42.requiredIndicator,
      s = _ref42.name,
      o = _ref42.fieldName,
      i = _ref42.label,
      l = _ref42.children,
      d = _ref42.description,
      u = _ref42.errors,
      _ref42$baseName = _ref42.baseName,
      m = _ref42$baseName === void 0 ? "nds-field" : _ref42$baseName,
      _ref42$className = _ref42.className,
      p = _ref42$className === void 0 ? c(m, "".concat(m, "--choice")) : _ref42$className,
      f = _ref42.labelClass,
      v = _ref42.descriptionClass,
      b = _ref42.errorsClass,
      g = _ref42.id,
      E = _ref42.labelId,
      w = _ref42.descriptionId,
      N = _ref42.errorsId,
      C = _ref42.onChange,
      _ = _objectWithoutProperties(_ref42, _excluded16);

  var _e$useState25 = e.useState(u),
      _e$useState26 = _slicedToArray(_e$useState25, 2),
      x = _e$useState26[0],
      M = _e$useState26[1],
      L = e.useMemo(function () {
    return t ? "checkbox" : "radio";
  }, [t]);

  e.useEffect(function () {
    return M(u);
  }, [u]);
  var $ = e.useRef(g || h("".concat(m, "-"))),
      O = e.useRef(E || "".concat($.current, "-label")),
      S = e.useRef(w || "".concat($.current, "-desc")),
      R = e.useRef(N || "".concat($.current, "-err")),
      z = e.useMemo(function () {
    return a && r ? "required" : n && !r ? "optional" : null;
  }, [a, n, r]),
      I = e.useCallback(function (r) {
    return e.isValidElement(r) ? e.cloneElement(r, {
      multiple: t
    }) : e.Children.map(r, function (t) {
      if (Array.isArray(t)) return I(t);
      var r = {
        name: s || $.current,
        type: L
      };
      var n, a;
      if ("string" == typeof t || "number" == typeof t) n = t, a = _objectSpread(_objectSpread({}, r), {}, {
        children: t
      });else {
        if (!e.isValidElement(t)) throw new Error("invalid children");
        n = (t.props.value || t.props.children || "").toString(), a = _objectSpread(_objectSpread({}, t.props), r);
      }
      return e.createElement(ye, y({}, a, {
        value: n
      }));
    });
  }, [s, L, t]),
      B = e.useMemo(function () {
    return I(l);
  }, [l, I]);
  return e.createElement("fieldset", y({
    ref: k,
    className: p,
    name: o,
    onChange: C
  }, _), e.createElement(fe, {
    label: i,
    labelClass: f,
    labelId: O.current,
    labelTag: "legend",
    description: d,
    descriptionClass: v,
    descriptionId: S.current,
    indicator: z
  }), B, e.createElement(ve, {
    errors: x,
    errorsId: R.current,
    errorsClass: b
  }));
});

Ne.Choice = ye, Ne.Choices = we;

var Ce = e.forwardRef(function (t, r) {
  return e.createElement(ye, y({
    type: "checkbox",
    ref: r
  }, t));
}),
    _e = function _e(t) {
  return e.createElement(Ne, y({
    multiple: !0
  }, t));
},
    ke = e.forwardRef(function (_ref43, n) {
  var t = _ref43.children,
      r = _objectWithoutProperties(_ref43, _excluded17);

  return e.createElement("details", y({
    ref: n
  }, r), t);
}),
    xe = e.forwardRef(function (_ref44, s) {
  var t = _ref44.marker,
      _ref44$markerPosition = _ref44.markerPosition,
      r = _ref44$markerPosition === void 0 ? "left" : _ref44$markerPosition,
      n = _ref44.children,
      a = _objectWithoutProperties(_ref44, _excluded18);

  return e.createElement("summary", y({
    ref: s
  }, a), e.createElement("div", {
    style: {
      display: "flex",
      width: "100%"
    }
  }, "left" === r && t, n, "right" === r && t));
}),
    Me = function Me(e) {
  try {
    var _t;

    var _r3 = function () {
      if (e) return _t = 1, Promise.resolve(e()).then(function (e) {
        return !1 !== e;
      });
    }();

    return Promise.resolve(_r3 && _r3.then ? _r3.then(function (e) {
      return !_t || e;
    }) : !_t || _r3);
  } catch (e) {
    return Promise.reject(e);
  }
},
    Le = e.forwardRef(function (_ref45, _) {
  var _c6;

  var _ref45$isOpen = _ref45.isOpen,
      t = _ref45$isOpen === void 0 ? !1 : _ref45$isOpen,
      r = _ref45.reducedMotion,
      n = _ref45.summary,
      a = _ref45.children,
      _ref45$marker = _ref45.marker,
      s = _ref45$marker === void 0 ? function (e) {
    return e ? "chevron-down" : "caret-right";
  } : _ref45$marker,
      _ref45$markerPosition = _ref45.markerPosition,
      o = _ref45$markerPosition === void 0 ? function (e) {
    return e ? "right" : "left";
  } : _ref45$markerPosition,
      i = _ref45.markerTransform,
      l = _ref45.panel,
      d = _ref45.className,
      _ref45$baseName = _ref45.baseName,
      u = _ref45$baseName === void 0 ? "nds-disclosure" : _ref45$baseName,
      _ref45$summaryClass = _ref45.summaryClass,
      m = _ref45$summaryClass === void 0 ? "".concat(u, "__summary") : _ref45$summaryClass,
      _ref45$markerClass = _ref45.markerClass,
      h = _ref45$markerClass === void 0 ? "".concat(u, "__marker") : _ref45$markerClass,
      _ref45$contentsOuterC = _ref45.contentsOuterClass,
      p = _ref45$contentsOuterC === void 0 ? "".concat(u, "__contents-outer") : _ref45$contentsOuterC,
      _ref45$contentsInnerC = _ref45.contentsInnerClass,
      f = _ref45$contentsInnerC === void 0 ? "".concat(u, "__contents-inner") : _ref45$contentsInnerC,
      v = _ref45.onCloseStart,
      b = _ref45.onCloseCancel,
      g = _ref45.onCloseEnd,
      E = _ref45.onOpenStart,
      w = _ref45.onOpenCancel,
      N = _ref45.onOpenEnd,
      C = _objectWithoutProperties(_ref45, _excluded19);

  var _e$useState27 = e.useState(t),
      _e$useState28 = _slicedToArray(_e$useState27, 2),
      k = _e$useState28[0],
      x = _e$useState28[1],
      _e$useState29 = e.useState(),
      _e$useState30 = _slicedToArray(_e$useState29, 2),
      M = _e$useState30[0],
      L = _e$useState30[1],
      _e$useState31 = e.useState(),
      _e$useState32 = _slicedToArray(_e$useState31, 2),
      $ = _e$useState32[0],
      S = _e$useState32[1],
      _e$useState33 = e.useState(),
      _e$useState34 = _slicedToArray(_e$useState33, 2),
      R = _e$useState34[0],
      z = _e$useState34[1],
      _e$useState35 = e.useState(null),
      _e$useState36 = _slicedToArray(_e$useState35, 2),
      I = _e$useState36[0],
      B = _e$useState36[1],
      P = e.useMemo(function () {
    return i || (l ? "flip-3d" : "rotate-90");
  }, [i, l]),
      D = e.useMemo(function () {
    return !r && (!I || window.getComputedStyle(I).getPropertyValue("transition-duration").split(/,\s*/).some(function (e) {
      return parseFloat(e) > 0;
    }));
  }, [r, I]),
      A = e.useCallback(function () {
    try {
      if (k || "opening" === $) return Promise.resolve();

      var _e6 = "closing" === $ ? Promise.resolve(Me(b)).then(function (e) {
        e && S(D ? "opening" : void 0);
      }) : Promise.resolve(Me(E)).then(function (e) {
        e && x(!0);
      });

      return Promise.resolve(_e6 && _e6.then ? _e6.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [k, $, D, b, E]),
      H = e.useCallback(function () {
    try {
      if (!k || "closing" === $) return Promise.resolve();

      var _e7 = "opening" === $ ? Promise.resolve(Me(w)).then(function (e) {
        e && S(D ? "closing" : void 0);
      }) : Promise.resolve(Me(v)).then(function (e) {
        e && (D ? (z({
          height: M
        }), window.requestAnimationFrame(function () {
          S("closing");
        })) : x(!1));
      });

      return Promise.resolve(_e7 && _e7.then ? _e7.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [k, $, M, D, w, v]);

  e.useEffect(function () {
    t ? A() : H();
  }, [t]), O(function () {
    k || S(void 0), k && I && (L(I.offsetHeight), D && (z({
      height: 0
    }), window.requestAnimationFrame(function () {
      S("opening");
    })));
  }, [k, I, D]), e.useEffect(function () {
    D ? ("opening" === $ && M && z({
      height: M
    }), "closing" === $ && z({
      height: 0
    })) : z(void 0);
  }, [$, M, D]);
  var T = e.useCallback(function (e) {
    if (e) return "string" == typeof e ? {
      variant: e
    } : "function" == typeof e ? T(e(l)) : {
      icon: e
    };
  }, [l]),
      V = e.useMemo(function () {
    if (!s) return;
    var t = T(s);
    return e.createElement("span", {
      className: h
    }, e.createElement(ae, y({}, t, {
      "data-transform": P
    })));
  }, [s, h, P, T]),
      F = e.useMemo(function () {
    if (o) return "function" == typeof o ? o(l) || void 0 : o;
  }, [o, l]),
      q = c(d, u, $ && "nds-".concat($), (_c6 = {}, _defineProperty(_c6, "".concat(u, "--panel"), l), _defineProperty(_c6, "nds-reduced-motion", !D), _c6));
  return e.createElement(ke, y({
    ref: _,
    className: q,
    open: k
  }, C), e.createElement(xe, {
    className: m,
    marker: V,
    onClick: function onClick(e) {
      e.preventDefault(), k ? H() : A();
    },
    markerPosition: F
  }, e.createElement("div", {
    className: "".concat(u, "__title")
  }, n)), k && e.createElement("div", {
    style: R,
    className: p,
    ref: B,
    onTransitionEnd: function onTransitionEnd() {
      S(void 0), z(void 0), "opening" === $ && N && N(), "closing" === $ && (x(!1), g && g());
    }
  }, e.createElement("div", {
    className: f
  }, a)));
}),
    $e = e.forwardRef(function (_ref46, l) {
  var _ref46$isSelected = _ref46.isSelected,
      t = _ref46$isSelected === void 0 ? !1 : _ref46$isSelected,
      r = _ref46.disabled,
      n = _ref46.children,
      a = _ref46.markerClass,
      s = _ref46.contentsClass,
      o = _ref46.value,
      i = _objectWithoutProperties(_ref46, _excluded20);

  return e.createElement("li", y({
    role: "option",
    "aria-selected": t ? "true" : void 0,
    "aria-disabled": r,
    ref: l
  }, i), e.createElement("span", {
    className: a,
    "aria-hidden": !t
  }, e.createElement(ae, {
    variant: r ? "close" : "check",
    className: a,
    "aria-label": r ? "Disabled" : "Check",
    size: "0.875em"
  })), e.createElement("span", {
    className: s
  }, n || o));
}),
    Oe = e.forwardRef(function (_ref47, h) {
  var t = _ref47.children,
      r = _ref47.className,
      n = _ref47.selected,
      _ref47$ariaOrientati = _ref47["aria-orientation"],
      a = _ref47$ariaOrientati === void 0 ? "vertical" : _ref47$ariaOrientati,
      s = _ref47.initialFocusIndex,
      o = _ref47.sort,
      i = _ref47.optionClass,
      l = _ref47.markerClass,
      c = _ref47.contentsClass,
      d = _ref47.onChange,
      u = _ref47.onFocusChange,
      m = _objectWithoutProperties(_ref47, _excluded21);

  var p = e.useMemo(function () {
    return o ? function (e, t) {
      var r = String(e.value).toUpperCase(),
          n = String(t.value).toUpperCase(),
          a = "descending" === o ? -1 : 1;
      return r < n ? -1 * a : r > n ? 1 * a : 0;
    } : null;
  }, [o]),
      f = e.useMemo(function () {
    var r = e.Children.map(t, function (t) {
      var r;

      if (e.isValidElement(t)) {
        if (t.type !== $e) throw new Error(Oe.errors.invalidChild);
        if (!t.props.value && !t.props.children) throw new Error(Oe.errors.noValue);
        r = _objectSpread(_objectSpread({}, t.props), {}, {
          value: "number" == typeof t.props.value || void 0 !== t.props.value ? t.props.value : t.props.children.toString()
        });
      } else r = {
        value: t.toString(),
        children: t
      };

      return r;
    });
    return p ? r.sort(p) : r;
  }, [t, p]),
      v = e.useMemo(function () {
    return Array.isArray(n) ? n : [n];
  }, [n]),
      b = e.useMemo(function () {
    return f.findIndex(function (_ref48) {
      var e = _ref48.value;
      return e === v[0];
    });
  }, [f, v]),
      _e$useState37 = e.useState(function () {
    return void 0 !== s ? s : b > -1 ? b : 0;
  }),
      _e$useState38 = _slicedToArray(_e$useState37, 2),
      g = _e$useState38[0],
      E = _e$useState38[1],
      w = e.useRef([]),
      N = function N(_ref49, r) {
    var e = _ref49.value,
        t = _ref49.contents;
    return function () {
      d && !r && d({
        value: e,
        contents: t
      }), E(f.findIndex(function (t) {
        return t.value === e;
      }));
    };
  },
      C = function C(e) {
    return function (t) {
      " " === t.key && "true" !== t.currentTarget.getAttribute("aria-disabled") && d && d(e);
    };
  },
      _ = f.map(function (t, r) {
    var n = t.children,
        s = t.disabled,
        o = t.value;
    return e.createElement(Oe.Option, y({
      key: o,
      className: i,
      markerClass: l,
      contentsClass: c,
      disabled: s,
      isSelected: v.includes(o),
      tabIndex: r === g ? 0 : -1,
      onClick: N({
        value: o,
        contents: n
      }, s),
      onKeyDown: (u = {
        value: o,
        contents: n
      }, function (e) {
        var t = "vertical" === a ? "ArrowDown" : "ArrowRight",
            r = "vertical" === a ? "ArrowUp" : "ArrowLeft";
        [t, r, "Home", "End", " "].includes(e.key) && e.preventDefault();
        var n = g;
        e.key === t && (n = g + 1), e.key === r && (n = g - 1), "End" === e.key && (n = f.length - 1), "Home" === e.key && (n = 0), n = Math.max(Math.min(n, f.length - 1), 0), n !== g && E(n), "Enter" === e.key && "true" !== e.currentTarget.getAttribute("aria-disabled") && d && d(u);
      }),
      onKeyUp: C({
        value: o,
        contents: n
      }),
      ref: function ref(e) {
        w.current.push(e), r === g && e && e.focus();
      }
    }, t));
    var u;
  });

  return O(function () {
    var e = w.current[g];
    e && (e.focus(), u && u(e));
  }, [g, w, u]), e.createElement("ul", y({
    role: "listbox",
    className: r,
    ref: h
  }, m), _);
});

Oe.Option = $e, Oe.errors = {
  invalidChild: "BaseListbox children must be Option components, strings, or numbers.",
  noValue: "Options must contain a value prop or children."
};

var Se = {
  name: "matchRefWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: function fn(_ref50) {
    var e = _ref50.state;
    e.styles.popper.width = "".concat(e.rects.reference.width, "px");
  },
  effect: function effect(_ref51) {
    var e = _ref51.state;
    return function () {
      e.elements.popper.style.width = "".concat(e.elements.reference.offsetWidth, "px");
    };
  }
},
    Re = function Re(_ref52) {
  var t = _ref52.label,
      r = _ref52.description,
      _ref52$isOpen = _ref52.isOpen,
      n = _ref52$isOpen === void 0 ? !1 : _ref52$isOpen,
      _ref52$selected = _ref52.selected,
      a = _ref52$selected === void 0 ? "" : _ref52$selected,
      _ref52$buttonContents = _ref52.buttonContents,
      s = _ref52$buttonContents === void 0 ? "Select" : _ref52$buttonContents,
      _ref52$closeOnExterna = _ref52.closeOnExternalClick,
      o = _ref52$closeOnExterna === void 0 ? !0 : _ref52$closeOnExterna,
      _ref52$closeOnDocumen = _ref52.closeOnDocumentEscape,
      i = _ref52$closeOnDocumen === void 0 ? !0 : _ref52$closeOnDocumen,
      l = _ref52.matchWidth,
      d = _ref52.buttonWidth,
      u = _ref52.sort,
      _ref52$baseName = _ref52.baseName,
      m = _ref52$baseName === void 0 ? "nds-dropdown" : _ref52$baseName,
      _ref52$buttonClass = _ref52.buttonClass,
      p = _ref52$buttonClass === void 0 ? "".concat(m, "__button") : _ref52$buttonClass,
      _ref52$listboxClass = _ref52.listboxClass,
      f = _ref52$listboxClass === void 0 ? "".concat(m, "__listbox") : _ref52$listboxClass,
      _ref52$optionClass = _ref52.optionClass,
      v = _ref52$optionClass === void 0 ? "".concat(m, "__option") : _ref52$optionClass,
      b = _ref52.labelClass,
      g = _ref52.descriptionClass,
      E = _ref52.onRequestClose,
      y = _ref52.onRequestOpen,
      w = _ref52.onChange,
      _ref52$placement = _ref52.placement,
      N = _ref52$placement === void 0 ? "bottom-start" : _ref52$placement,
      _ref52$modifiers = _ref52.modifiers,
      _ = _ref52$modifiers === void 0 ? [{
    name: "offset",
    options: {
      offset: [0, 4]
    }
  }] : _ref52$modifiers,
      k = _ref52.strategy,
      x = _ref52.onFirstUpdate,
      M = _ref52.children,
      L = _ref52.id,
      $ = _ref52.labelId,
      S = _ref52.descriptionId,
      z = _ref52.buttonId,
      I = _ref52.listboxId,
      B = _ref52.disabled,
      P = _ref52.className;

  var _e$useState39 = e.useState(n),
      _e$useState40 = _slicedToArray(_e$useState39, 2),
      D = _e$useState40[0],
      A = _e$useState40[1],
      _e$useState41 = e.useState(a),
      _e$useState42 = _slicedToArray(_e$useState41, 2),
      H = _e$useState42[0],
      T = _e$useState42[1],
      _e$useState43 = e.useState(s),
      _e$useState44 = _slicedToArray(_e$useState43, 2),
      V = _e$useState44[0],
      F = _e$useState44[1],
      _e$useState45 = e.useState(null),
      _e$useState46 = _slicedToArray(_e$useState45, 2),
      q = _e$useState46[0],
      U = _e$useState46[1],
      _e$useState47 = e.useState(null),
      _e$useState48 = _slicedToArray(_e$useState47, 2),
      K = _e$useState48[0],
      W = _e$useState48[1],
      _e$useState49 = e.useState(),
      _e$useState50 = _slicedToArray(_e$useState49, 2),
      j = _e$useState50[0],
      G = _e$useState50[1],
      _e$useState51 = e.useState(!1),
      _e$useState52 = _slicedToArray(_e$useState51, 2),
      Z = _e$useState52[0],
      Y = _e$useState52[1],
      J = e.useRef(!1),
      Q = e.useRef(L || h("".concat(m, "-"))),
      X = e.useRef($ || "".concat(Q.current, "-label")),
      ee = e.useRef(S || "".concat(Q.current, "-desc")),
      te = e.useRef(z || "".concat(Q.current, "-btn")),
      re = e.useRef(I || "".concat(Q.current, "-listbox")),
      ne = e.useRef("".concat(Q.current, "-curr"));

  R({
    reference: q,
    popper: K,
    placement: N,
    modifiers: "button" === l ? [].concat(_toConsumableArray(_), [Se]) : _,
    strategy: k,
    onFirstUpdate: x
  }), e.useEffect(function () {
    return A(n);
  }, [n]), e.useEffect(function () {
    return T(a);
  }, [a]), e.useEffect(function () {
    return F(s);
  }, [s]);
  var ae = e.useCallback(function () {
    y ? y() : A(!0);
  }, [y]),
      se = e.useCallback(function () {
    E ? E() : A(!1);
  }, [E]),
      oe = e.useCallback(function (e) {
    D && (i && "Escape" === e.key && (Y(!0), se()), "Tab" === e.key && (Y(!1), se()));
  }, [D, se, i]),
      ie = e.useCallback(function (e) {
    var t = e.composedPath(),
        r = q && t.includes(q),
        n = K && t.includes(K);
    !o || r || n || (Y(!1), se());
  }, [q, K, o, se]);
  return e.useEffect(function () {
    B && (Y(!0), se());
  }, [B, se]), e.useEffect(function () {
    !D && Z && null !== q && (C && "requestAnimationFrame" in window && window.requestAnimationFrame(function () {
      return q.focus();
    }), Y(!1));
  }, [q, D, Z]), O(function () {
    return document.addEventListener("keydown", oe), document.addEventListener("click", ie), function () {
      document.removeEventListener("keydown", oe), document.removeEventListener("click", ie);
    };
  }, [oe, ie]), O(function () {
    K && G(K.offsetWidth);
  }, [K]), O(function () {
    "number" == typeof j && J.current && (A(n), J.current = !1);
  }, [j, n]), e.useEffect(function () {
    "listbox" === l && (A(!0), J.current = !0);
  }, []), e.createElement("div", {
    className: c(m, P),
    id: Q.current
  }, e.createElement(fe, {
    label: t,
    labelClass: b,
    labelId: X.current,
    description: r,
    descriptionClass: g,
    descriptionId: ee.current
  }), e.createElement(ce, {
    id: te.current,
    className: p,
    disabled: B,
    variant: "outline",
    style: {
      width: "listbox" === l ? j : d
    },
    "aria-expanded": D ? "true" : void 0,
    "aria-labelledby": "".concat(X.current, " ").concat(ne.current),
    "aria-haspopup": "listbox",
    "aria-controls": D ? re.current : void 0,
    onClick: function onClick() {
      D ? se() : ae();
    },
    onKeyDown: function onKeyDown(e) {
      ["ArrowDown", "ArrowUp"].includes(e.key) && (e.preventDefault(), ae());
    },
    ref: U,
    icon: J.current ? void 0 : "chevron-down",
    iconRight: !0
  }, e.createElement("span", {
    id: ne.current
  }, V)), D && e.createElement(Oe, {
    id: re.current,
    sort: u,
    selected: H,
    className: f,
    "aria-labelledby": X.current,
    optionClass: v,
    markerClass: "".concat(v, "-marker"),
    contentsClass: "".concat(v, "-label"),
    onChange: function onChange(_ref53) {
      var e = _ref53.value,
          t = _ref53.contents;
      w ? w({
        value: e,
        contents: t
      }) : T(e), F(t || e), Y(!0), se();
    },
    ref: W
  }, M));
};

Re.Option = Oe.Option;

var ze = e.forwardRef(function (t, r) {
  var n = L();
  if (n) return e.createElement(n, y({
    className: "nds-link",
    ref: r
  }, t));

  var a = t.external,
      s = t.children,
      o = _objectWithoutProperties(t, _excluded22);

  return e.createElement("a", y({
    className: "nds-link",
    rel: a ? "noopener noreferrer" : void 0,
    target: a ? "_blank" : void 0,
    ref: r
  }, o), s, a && e.createElement("span", {
    className: "nds-link__launch"
  }, e.createElement(ae, {
    size: "1em",
    variant: "launch"
  })));
}),
    Ie = e.forwardRef(function (_ref54, d) {
  var t = _ref54.disabled,
      r = _ref54.label,
      n = _ref54.selected,
      a = _ref54.marker,
      _ref54$className = _ref54.className,
      s = _ref54$className === void 0 ? "nds-option" : _ref54$className,
      o = _ref54.onClick,
      i = _ref54.onKeyDown,
      l = _ref54.children,
      c = _objectWithoutProperties(_ref54, _excluded23);

  var u = e.useMemo(function () {
    return e.createElement("span", {
      className: "nds-option__marker",
      "aria-hidden": !n
    }, e.createElement(ae, {
      variant: "check",
      color: n ? "currentColor" : "transparent",
      "aria-label": n ? "Checked" : void 0,
      size: "0.875em"
    }));
  }, [n]);
  return e.createElement("li", y({
    ref: d,
    className: s,
    onClick: t ? void 0 : o,
    onKeyDown: t ? void 0 : i
  }, c, {
    "aria-selected": n ? "true" : "false",
    "aria-disabled": t ? "true" : void 0,
    role: "option"
  }), void 0 === a ? u : a, r || l);
}),
    Be = e.forwardRef(function (_ref55, p) {
  var t = _ref55.options,
      r = _ref55.optionProps,
      n = _ref55.multiselectable,
      a = _ref55.selected,
      s = _ref55.onChange,
      o = _ref55.autofocus,
      i = _ref55.focusableIndex,
      l = _ref55.focusWrap,
      c = _ref55.onOptionFocus,
      _ref55$className = _ref55.className,
      d = _ref55$className === void 0 ? "nds-listbox" : _ref55$className,
      u = _ref55.children,
      m = _ref55.orientation,
      h = _objectWithoutProperties(_ref55, _excluded24);

  var _k13 = k(p),
      _k14 = _slicedToArray(_k13, 2),
      f = _k14[0],
      v = _k14[1],
      _e$useState53 = e.useState(!1),
      _e$useState54 = _slicedToArray(_e$useState53, 2),
      b = _e$useState54[0],
      g = _e$useState54[1],
      E = e.useRef(new Set()),
      w = e.useMemo(function () {
    var e = u;
    return t && (e = Array.isArray(t) ? t.map(function (e) {
      if ("object" == typeof e) {
        var _t2 = [];
        if ("value" in e || _t2.push("value"), "label" in e || _t2.push("label"), _t2.length) throw new Error("The <Listbox> options prop must contain a value and label when an array of objects. Missing props: ".concat(_t2.join(","), "."));
        return e;
      }

      return {
        label: e.toString(),
        value: e
      };
    }) : Object.keys(t).map(function (e) {
      return {
        label: e,
        value: t[e]
      };
    })), N(e);
  }, [t, u]),
      C = e.useMemo(function () {
    return w.filter(function (_ref56) {
      var e = _ref56.props;
      return e.selected;
    }).map(function (_ref57) {
      var e = _ref57.props;
      return e.value;
    });
  }, [w]),
      _B = B(n, C),
      _ = _B.selected,
      x = _B.toggle,
      M = void 0 !== a ? a : _;

  e.useEffect(function () {
    if (!n && M.length > 1) throw new Error(B.SELECT_OVERLOAD);
  }, [n, M]);

  var L = e.useMemo(function () {
    switch (m) {
      case "vertical":
        return {
          nextKeys: ["ArrowDown"],
          prevKeys: ["ArrowUp"]
        };

      case "horizontal":
        return {
          nextKeys: ["ArrowRight"],
          prevKeys: ["ArrowLeft"]
        };

      default:
        return {};
    }
  }, [m]),
      _I = I(_objectSpread({
    container: f,
    size: w.length,
    initialIndex: i,
    wrap: l,
    autofocus: o,
    disabledItems: E.current
  }, L)),
      $ = _I.dispatch,
      _I$containerProps = _I.containerProps,
      O = _I$containerProps.onKeyDown,
      S = _I$containerProps.onBlur,
      _I$childProps = _I.childProps,
      R = _I$childProps.createRef,
      z = _I$childProps.tabIndex,
      P = e.useMemo(function () {
    return w.map(function (_ref58, n) {
      var t = _ref58.props;

      var o = "function" == typeof r ? r(n) : r,
          _o$t = _objectSpread(_objectSpread({}, o), t),
          i = _o$t.children,
          l = _o$t.disabled,
          d = _o$t.value,
          _o$t$label = _o$t.label,
          u = _o$t$label === void 0 ? i || d : _o$t$label,
          m = _o$t.selected,
          h = _objectWithoutProperties(_o$t, _excluded25);

      if (!d) throw new Error("<Option> elements must provide a value prop.");
      l ? E.current.add(n) : E.current.delete(n);

      var p = function p() {
        s ? s(_objectSpread(_objectSpread({
          children: i,
          disabled: l
        }, h), {}, {
          value: d,
          label: u
        })) : a || x(d);
      };

      return e.createElement(Ie, y({
        key: d,
        value: d,
        label: u,
        selected: M.includes(d),
        disabled: l,
        tabIndex: l ? -1 : z(n),
        onClick: function onClick(e) {
          l ? e.preventDefault() : ($({
            type: "GOTO",
            payload: n
          }), p());
        },
        onKeyDown: function onKeyDown(e) {
          "Enter" === e.key && p(), " " === e.key && (e.preventDefault(), g(!0));
        },
        onKeyUp: function onKeyUp(_ref59) {
          var e = _ref59.key;
          " " === e && b && (p(), g(!1));
        },
        onBlur: function onBlur() {
          return g(!1);
        },
        onFocus: function onFocus(e) {
          c && c(e, n);
        },
        ref: l ? void 0 : R(n)
      }, h), i);
    });
  }, [R, $, b, s, c, r, w, M, a, z, x]);

  return e.createElement("ul", y({
    ref: v,
    className: d,
    "aria-orientation": m,
    onKeyDown: O,
    onBlur: S
  }, h, {
    role: "listbox",
    "aria-multiselectable": n
  }), P);
}),
    Pe = ['[contentEditable=true]:not([tabindex="-1"])', '[tabindex]:not([tabindex="-1"])', 'a[href]:not([tabindex="-1"])', 'button:not([disabled]):not([tabindex="-1"])', "dialog", 'embed:not([tabindex="-1"])', 'iframe:not([tabindex="-1"])', 'input:not([disabled]):not([tabindex="-1"])', 'map[name] area[href]:not([tabindex="-1"])', 'object:not([tabindex="-1"])', 'select:not([disabled]):not([tabindex="-1"])', 'summary:not([tabindex="-1"])', 'textarea:not([disabled]):not([tabindex="-1"])'],
    De = function De(e) {
  return e.querySelectorAll(Pe.join(","));
},
    Ae = e.forwardRef(function (_ref60, a) {
  var t = _ref60.modal,
      r = _ref60.children,
      n = _objectWithoutProperties(_ref60, _excluded26);

  return e.createElement("div", y({
    role: "dialog",
    ref: a,
    "aria-modal": t ? "true" : "false"
  }, n), r);
});

var He = /*#__PURE__*/function (_e$PureComponent) {
  _inherits(He, _e$PureComponent);

  var _super = _createSuper(He);

  function He(e) {
    var _this;

    _classCallCheck(this, He);

    _this = _super.call(this, e), _this.baseName = void 0, _this.id = void 0, _this.titleId = void 0, _this.portalNode = void 0, _this.dialog = null, _this.header = null, _this.content = null, _this.footer = null, _this.stickyObserver = null, _this.open = function () {
      _this.setState({
        isOpen: !0,
        trigger: document.activeElement
      });
    }, _this.close = function () {
      _this.setState({
        isOpen: !1
      });
    }, _this.requestClose = function () {
      var e = _this.props.onRequestClose;
      e && e();
    }, _this.updateLength = function () {
      if (_this.dialog) {
        var _e8 = _this.dialog.offsetHeight > window.innerHeight - 80;

        _this.setState({
          long: _e8,
          stuckFooter: _e8
        });
      }
    }, _this.onBackdropClick = function (_ref61) {
      var e = _ref61.nativeEvent;
      var t = _this.props.closeOnBackdropClick;
      t && _this.dialog && !e.composedPath().includes(_this.dialog) && _this.requestClose();
    }, _this.onDocumentKeydown = function (e) {
      var t = _this.props.closeOnEscape,
          r = _this.state.isOpen;

      if (r && ("Escape" === e.key && t && _this.requestClose(), "Tab" === e.key)) {
        var _t3 = _this.dialog ? De(_this.dialog) : [];

        if (_t3.length) {
          var _r4;

          var _n10 = Array.from(_t3).indexOf(document.activeElement),
              _a2 = _n10 === _t3.length - 1 && !e.shiftKey;

          (_n10 < 0 || _a2) && (_r4 = _t3[0]), 0 === _n10 && e.shiftKey && (_r4 = _t3[_t3.length - 1]), _r4 && (e.preventDefault(), _r4.focus());
        } else e.preventDefault();
      }
    }, _this.baseName = e.baseName || He.bemBase, _this.id = e.id || h("".concat(_this.baseName, "-")), _this.titleId = "".concat(_this.id, "-").concat(He.bemElements.title), _this.portalNode = C ? _this.createPortalNode() : null, _this.state = {
      isOpen: e.isOpen || He.defaultProps.isOpen,
      trigger: null,
      long: !1,
      stuckHeader: !1,
      stuckFooter: !1,
      bodyOverflow: ""
    };
    return _this;
  }

  _createClass(He, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!C || !this.portalNode) return;

      if ("IntersectionObserver" in window && (this.stickyObserver = new IntersectionObserver(function (_ref62) {
        var _ref63 = _slicedToArray(_ref62, 1),
            e = _ref63[0];

        e.target === _this2.header && _this2.setState({
          stuckHeader: e.intersectionRatio < 1
        }), e.target === _this2.footer && _this2.setState({
          stuckFooter: e.intersectionRatio < 1
        });
      }, {
        threshold: [1]
      })), !document.contains(this.portalNode)) {
        var _this$props$mountPoin = this.props.mountPoint,
            _e9 = _this$props$mountPoin === void 0 ? He.defaultProps.mountPoint : _this$props$mountPoin;

        _e9().appendChild(this.portalNode);
      }

      var e = this.state.isOpen;
      e && this.onOpen();
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(_ref64) {
      var _ref64$mountPoint = _ref64.mountPoint,
          e = _ref64$mountPoint === void 0 ? He.defaultProps.mountPoint : _ref64$mountPoint;
      var _this$props$mountPoin2 = this.props.mountPoint,
          t = _this$props$mountPoin2 === void 0 ? He.defaultProps.mountPoint : _this$props$mountPoin2;
      return {
        prevMount: e(),
        nextMount: t()
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e, t, _ref65) {
      var r = _ref65.prevMount,
          n = _ref65.nextMount;
      if (!C || !this.portalNode) return;
      var _this$props = this.props,
          a = _this$props.isOpen,
          s = _this$props.children,
          o = _this$props.focusOnOpen,
          _this$props$portalCla = _this$props.portalClass,
          i = _this$props$portalCla === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.portal) : _this$props$portalCla,
          l = this.state.isOpen;
      e.portalClass !== i && (this.portalNode.className = i), n !== r && (r.removeChild(this.portalNode), n.appendChild(this.portalNode)), !e.isOpen && a ? this.open() : e.isOpen && !a && this.close(), !t.isOpen && l ? this.onOpen() : t.isOpen && !l && this.onClose(), e.children !== s && this.updateLength(), l && !e.focusOnOpen && o && o.focus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!C || !this.portalNode) return;
      this.portalNode.remove(), document.removeEventListener("keydown", this.onDocumentKeydown);
      var e = this.state.bodyOverflow;
      document.body.style.overflow = e;
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      var e = this.props.focusOnOpen;
      var t = e || null;

      if (!t) {
        var _e10 = this.dialog ? De(this.dialog) : [];

        t = _e10.length ? _e10[0] : null;
      }

      t || (t = this.header || this.content, t && t.setAttribute("tabIndex", "-1")), t && t.focus(), this.updateLength(), this.stickyObserver && (this.header && this.stickyObserver.observe(this.header), this.footer && this.stickyObserver.observe(this.footer)), document.addEventListener("keydown", this.onDocumentKeydown), this.setState({
        bodyOverflow: document.body.style.overflow
      }), document.body.style.overflow = "hidden";
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this$state = this.state,
          e = _this$state.trigger,
          t = _this$state.bodyOverflow;
      this.stickyObserver && (this.header && this.stickyObserver.unobserve(this.header), this.footer && this.stickyObserver.unobserve(this.footer)), document.removeEventListener("keydown", this.onDocumentKeydown), e && e.focus(), document.body.style.overflow = t;
    }
  }, {
    key: "CloseButton",
    get: function get() {
      var _this$props2 = this.props,
          t = _this$props2.hideCloseButton,
          _this$props2$closeBut = _this$props2.closeButtonClass,
          r = _this$props2$closeBut === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.closeButton) : _this$props2$closeBut;
      return t ? null : e.createElement(de, {
        icon: "close",
        className: c(r, "button--base"),
        onClick: this.requestClose
      }, "Close");
    }
  }, {
    key: "Title",
    get: function get() {
      var _this$props3 = this.props,
          _this$props3$titleCla = _this$props3.titleClass,
          t = _this$props3$titleCla === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.title) : _this$props3$titleCla,
          r = _this$props3.title,
          n = _this$props3.hideTitle;
      return n ? null : e.createElement("h2", {
        className: t,
        id: this.titleId
      }, r);
    }
  }, {
    key: "Header",
    get: function get() {
      var _c7,
          _this3 = this;

      var _this$props4 = this.props,
          _this$props4$headerCl = _this$props4.headerClass,
          t = _this$props4$headerCl === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.header) : _this$props4$headerCl,
          r = _this$props4.stickyHeader;
      if (!this.Title && !this.CloseButton) return null;
      var _this$state2 = this.state,
          n = _this$state2.stuckHeader,
          a = _this$state2.long,
          s = c(t, (_c7 = {}, _defineProperty(_c7, "".concat(t, "--sticky"), r && a), _defineProperty(_c7, "nds-stuck", r && n), _c7));
      return e.createElement("header", {
        className: s,
        ref: function ref(e) {
          _this3.header = e;
        }
      }, this.Title, this.CloseButton);
    }
  }, {
    key: "ActionBar",
    get: function get() {
      var _c8,
          _this4 = this;

      var _this$props5 = this.props,
          _this$props5$actionBa = _this$props5.actionBarClass,
          t = _this$props5$actionBa === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.actionBar) : _this$props5$actionBa,
          r = _this$props5.stickyActionBar,
          n = _this$props5.actions;
      if (!n) return null;
      var _this$state3 = this.state,
          a = _this$state3.stuckFooter,
          s = _this$state3.long,
          o = c(t, (_c8 = {}, _defineProperty(_c8, "".concat(t, "--sticky"), r && s), _defineProperty(_c8, "nds-stuck", r && a), _c8));
      return e.createElement("footer", {
        className: o,
        ref: function ref(e) {
          _this4.footer = e;
        }
      }, n);
    }
  }, {
    key: "Dialog",
    get: function get() {
      var _this5 = this;

      var _this$props6 = this.props,
          t = _this$props6.title,
          r = _this$props6.hideTitle,
          n = _this$props6.className,
          a = _this$props6.children,
          _this$props6$contentC = _this$props6.contentClass,
          s = _this$props6$contentC === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.content) : _this$props6$contentC,
          _this$props6$backdrop = _this$props6.backdropClass,
          o = _this$props6$backdrop === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.backdrop) : _this$props6$backdrop,
          _this$state4 = this.state,
          i = _this$state4.isOpen,
          l = _this$state4.long;
      if (!i) return null;
      var d = c(this.baseName, n),
          u = r ? {
        "aria-label": t
      } : {
        "aria-labelledby": this.titleId
      };
      return e.createElement("section", {
        className: c(o, _defineProperty({}, "".concat(this.baseName, "--long"), l)),
        onClick: this.onBackdropClick
      }, e.createElement(Ae, y({
        modal: !0,
        id: this.id,
        className: d,
        ref: function ref(e) {
          _this5.dialog = e;
        }
      }, u), this.Header, e.createElement("section", {
        className: s,
        ref: function ref(e) {
          _this5.content = e;
        }
      }, a), this.ActionBar));
    }
  }, {
    key: "createPortalNode",
    value: function createPortalNode() {
      var _this$props$portalCla2 = this.props.portalClass,
          e = _this$props$portalCla2 === void 0 ? "".concat(this.baseName, "__").concat(He.bemElements.portal) : _this$props$portalCla2,
          t = document.createElement("div");
      return t.className = e, t;
    }
  }, {
    key: "render",
    value: function render() {
      return C && this.portalNode ? v.createPortal(this.Dialog, this.portalNode) : null;
    }
  }]);

  return He;
}(e.PureComponent);

He.bemBase = "nds-modal", He.bemElements = {
  portal: "portal",
  backdrop: "backdrop",
  header: "header",
  title: "title",
  closeButton: "close",
  content: "content",
  actionBar: "actionbar"
}, He.defaultProps = {
  isOpen: !1,
  mountPoint: function mountPoint() {
    return document.body;
  },
  hideTitle: !1,
  closeOnBackdropClick: !0,
  closeOnEscape: !0
};

var Te = e.forwardRef(function (_ref66, A) {
  var t = _ref66.isOpen,
      _ref66$transition = _ref66.transition,
      r = _ref66$transition === void 0 ? "fade" : _ref66$transition,
      n = _ref66.reference,
      a = _ref66.arrowElement,
      s = _ref66.distance,
      o = _ref66.boundary,
      _ref66$placement = _ref66.placement,
      i = _ref66$placement === void 0 ? "top" : _ref66$placement,
      l = _ref66.modifiers,
      d = _ref66.strategy,
      u = _ref66.onFirstUpdate,
      _ref66$hideDelay = _ref66.hideDelay,
      m = _ref66$hideDelay === void 0 ? 300 : _ref66$hideDelay,
      p = _ref66.showDelay,
      f = _ref66.onRequestOpen,
      v = _ref66.onRequestClose,
      b = _ref66.title,
      g = _ref66.hideTitle,
      E = _ref66.hideCloseButton,
      w = _ref66.actions,
      _ref66$baseName = _ref66.baseName,
      N = _ref66$baseName === void 0 ? "nds-popover" : _ref66$baseName,
      _ref66$headerClass = _ref66.headerClass,
      C = _ref66$headerClass === void 0 ? "".concat(N, "__header") : _ref66$headerClass,
      _ref66$titleClass = _ref66.titleClass,
      _ = _ref66$titleClass === void 0 ? "".concat(N, "__title") : _ref66$titleClass,
      _ref66$closeButtonCla = _ref66.closeButtonClass,
      x = _ref66$closeButtonCla === void 0 ? "".concat(N, "__close") : _ref66$closeButtonCla,
      _ref66$bodyClass = _ref66.bodyClass,
      M = _ref66$bodyClass === void 0 ? "".concat(N, "__body") : _ref66$bodyClass,
      _ref66$actionBarClass = _ref66.actionBarClass,
      L = _ref66$actionBarClass === void 0 ? "".concat(N, "__actions") : _ref66$actionBarClass,
      $ = _ref66.arrowClass,
      _ref66$onClose = _ref66.onClose,
      O = _ref66$onClose === void 0 ? function (e) {
    e && n instanceof HTMLElement && n.focus();
  } : _ref66$onClose,
      _ref66$onOpen = _ref66.onOpen,
      S = _ref66$onOpen === void 0 ? function (e) {
    e && e.focus();
  } : _ref66$onOpen,
      R = _ref66.children,
      I = _ref66.className,
      B = _ref66["aria-labelledby"],
      P = _ref66["aria-label"],
      D = _objectWithoutProperties(_ref66, _excluded27);

  var _k15 = k(A),
      _k16 = _slicedToArray(_k15, 2),
      H = _k16[0],
      T = _k16[1],
      V = e.useRef(h("".concat(N, "-title-"))),
      F = e.useRef(!0),
      q = e.useRef(t),
      U = e.useCallback(function (e) {
    F.current = "click.external" !== e, v && v(e);
  }, [v]);

  z({
    reference: n,
    popper: H,
    trigger: "click",
    isOpen: t,
    hideDelay: m,
    showDelay: p,
    onRequestClose: U,
    onRequestOpen: function onRequestOpen(e) {
      f && f(e);
    }
  });
  var K = e.useMemo(function () {
    return !g && b || !E ? e.createElement("header", {
      className: C
    }, !g && b && e.createElement("div", {
      className: _,
      id: V.current
    }, b), !E && e.createElement(ce, {
      icon: "close",
      iconOnly: !0,
      className: x,
      onClick: function onClick() {
        return U("click.internal");
      },
      tooltipProps: {
        placement: "left"
      }
    }, "Close")) : null;
  }, [U, x, C, E, g, b, _]),
      W = e.useMemo(function () {
    return w ? e.createElement("footer", {
      className: L
    }, w) : null;
  }, [L, w]);
  e.useEffect(function () {
    !q.current && t && H && (S(H), q.current = !0), q.current && !t && (O(F.current), q.current = !1);
  }, [t, O, S, H]);
  var j = e.useMemo(function () {
    return B ? {
      "aria-labelledby": B
    } : P ? {
      "aria-label": P
    } : g ? {
      "aria-label": b
    } : {
      "aria-labelledby": V.current
    };
  }, [P, B, g, b]);
  return R ? e.createElement(re, y({
    className: c(N, I),
    "data-no-title": g || !b ? "" : void 0,
    role: "dialog",
    "aria-modal": "false"
  }, j, {
    tabIndex: -1,
    isOpen: t,
    transition: r,
    reference: n,
    arrowElement: a || $,
    distance: s,
    boundary: o,
    placement: i,
    modifiers: l,
    strategy: d,
    onFirstUpdate: u,
    enableArrow: !0,
    ref: T
  }, D), K, e.createElement("section", {
    className: M
  }, R), W) : null;
}),
    Ve = e.forwardRef(function (_ref67, s) {
  var t = _ref67.progress,
      _ref67$max = _ref67.max,
      r = _ref67$max === void 0 ? 1 : _ref67$max,
      n = _ref67.children,
      a = _objectWithoutProperties(_ref67, _excluded28);

  return e.createElement("div", y({
    role: "progressbar",
    "aria-valuenow": t,
    "aria-valuemax": r,
    "aria-valuemin": 0,
    ref: s
  }, a), n);
}),
    Fe = e.forwardRef(function (_ref68, l) {
  var t = _ref68.progress,
      a = _ref68.buffer,
      s = _ref68.reversed,
      o = _ref68.className,
      i = _objectWithoutProperties(_ref68, _excluded29);

  var _k17 = k(l),
      _k18 = _slicedToArray(_k17, 2),
      d = _k18[0],
      u = _k18[1],
      _n11 = n(),
      _n12 = _slicedToArray(_n11, 2),
      m = _n12[0],
      h = _n12[1],
      p = c(o, "mdc-linear-progress", {
    "mdc-linear-progress--indeterminate": void 0 === t,
    "mdc-linear-progress--reversed": s
  });

  return O(function () {
    d && h(new E(d));
  }, [d]), r(function () {
    void 0 !== a && m && (m.buffer = a);
  }, [a, m]), r(function () {
    m && (void 0 !== t && (m.progress = t), m.determinate = void 0 !== t);
  }, [t, m]), e.createElement(Ve, y({
    className: p,
    progress: t,
    dir: s ? "rtl" : void 0,
    max: 1,
    ref: u
  }, i), e.createElement("div", {
    className: "mdc-linear-progress__buffer"
  }, e.createElement("div", {
    className: "mdc-linear-progress__buffer-bar"
  }), e.createElement("div", {
    className: "mdc-linear-progress__buffer-dots"
  })), e.createElement("div", {
    className: "mdc-linear-progress__bar mdc-linear-progress__primary-bar"
  }, e.createElement("span", {
    className: "mdc-linear-progress__bar-inner"
  })), e.createElement("div", {
    className: "mdc-linear-progress__bar mdc-linear-progress__secondary-bar"
  }, e.createElement("span", {
    className: "mdc-linear-progress__bar-inner"
  })));
}),
    qe = {
  cy: 24,
  cx: 24,
  r: 18
},
    Ue = {
  "aria-hidden": !0,
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
},
    Ke = e.forwardRef(function (_ref69, o) {
  var _ref69$size = _ref69.size,
      t = _ref69$size === void 0 ? "2rem" : _ref69$size,
      _ref69$strokeWidth = _ref69.strokeWidth,
      r = _ref69$strokeWidth === void 0 ? 4 : _ref69$strokeWidth,
      n = _ref69.progress,
      a = _ref69.className,
      s = _objectWithoutProperties(_ref69, _excluded30);

  var i = void 0 !== n,
      l = c(a, "mdc-circular-progress", {
    "mdc-circular-progress--indeterminate": !i
  });
  return e.createElement(Ve, y({
    className: l,
    progress: n,
    max: 1,
    style: {
      width: t,
      height: t
    },
    ref: o
  }, s), i ? e.createElement("div", {
    className: "mdc-circular-progress__determinate-container"
  }, e.createElement("svg", y({
    className: "mdc-circular-progress__determinate-circle-graphic"
  }, Ue), e.createElement("circle", y({
    className: "mdc-circular-progress__determinate-track"
  }, qe, {
    strokeWidth: r
  })), e.createElement("circle", y({
    className: "mdc-circular-progress__determinate-circle"
  }, qe, {
    strokeDasharray: 113.097,
    strokeDashoffset: n ? (1 - n) * (2 * Math.PI * Number(qe.r)) : 113.097,
    strokeWidth: r
  })))) : e.createElement("div", {
    className: "mdc-circular-progress__indeterminate-container"
  }, e.createElement("div", {
    className: "mdc-circular-progress__spinner-layer"
  }, e.createElement("div", {
    className: "mdc-circular-progress__circle-clipper mdc-circular-progress__circle-left"
  }, e.createElement("svg", y({
    className: "mdc-circular-progress__indeterminate-circle-graphic"
  }, Ue), e.createElement("circle", y({}, qe, {
    strokeDasharray: 113.097,
    strokeDashoffset: 56.5485,
    strokeWidth: r
  })))), e.createElement("div", {
    className: "mdc-circular-progress__gap-patch"
  }, e.createElement("svg", y({
    className: "mdc-circular-progress__indeterminate-circle-graphic"
  }, Ue), e.createElement("circle", y({}, qe, {
    strokeDasharray: 113.097,
    strokeDashoffset: 56.5485,
    strokeWidth: .8 * r
  })))), e.createElement("div", {
    className: "mdc-circular-progress__circle-clipper mdc-circular-progress__circle-right"
  }, e.createElement("svg", y({
    className: "mdc-circular-progress__indeterminate-circle-graphic"
  }, Ue), e.createElement("circle", y({}, qe, {
    strokeDasharray: 113.097,
    strokeDashoffset: 56.5485,
    strokeWidth: r
  })))))));
}),
    We = e.forwardRef(function (_ref70, l) {
  var t = _ref70.label,
      r = _ref70.hideLabel,
      n = _ref70.size,
      _ref70$baseName = _ref70.baseName,
      a = _ref70$baseName === void 0 ? "nds-progressbar" : _ref70$baseName,
      _ref70$labelClass = _ref70.labelClass,
      s = _ref70$labelClass === void 0 ? "".concat(a, "__label") : _ref70$labelClass,
      o = _ref70.className,
      i = _objectWithoutProperties(_ref70, _excluded31);

  var d = e.useRef(g("".concat(a, "-label-"))),
      u = c(o, a, n && "".concat(a, "--").concat(n));
  return e.createElement("div", {
    className: u
  }, e.createElement(Fe, y({
    ref: l,
    "aria-labelledby": r ? void 0 : d.current,
    "aria-label": r ? t : void 0
  }, i)), !r && e.createElement("div", {
    className: s,
    id: d.current,
    "aria-hidden": "true"
  }, t));
}),
    je = e.forwardRef(function (t, r) {
  return e.createElement(ye, y({
    type: "radio",
    ref: r
  }, t));
}),
    Ge = function Ge(t) {
  return e.createElement(Ne, y({
    multiple: !1
  }, t));
},
    Ze = e.forwardRef(function (_ref71, u) {
  var _ref71$label = _ref71.label,
      t = _ref71$label === void 0 ? "Loading..." : _ref71$label,
      r = _ref71.color,
      _ref71$baseName = _ref71.baseName,
      n = _ref71$baseName === void 0 ? "nds-spinner" : _ref71$baseName,
      _ref71$labelClass = _ref71.labelClass,
      a = _ref71$labelClass === void 0 ? "".concat(n, "__label") : _ref71$labelClass,
      _ref71$labelPosition = _ref71.labelPosition,
      s = _ref71$labelPosition === void 0 ? "right" : _ref71$labelPosition,
      o = _ref71.hideLabel,
      _ref71$size = _ref71.size,
      i = _ref71$size === void 0 ? "3rem" : _ref71$size,
      l = _ref71.className,
      d = _objectWithoutProperties(_ref71, _excluded32);

  var m = o ? void 0 : s,
      h = e.useRef(g("".concat(n, "-label-"))),
      p = c(l, n, _defineProperty({}, "".concat(n, "--").concat(r), void 0 !== r));
  return e.createElement("div", {
    className: p,
    "data-label": o ? void 0 : m
  }, e.createElement(Ke, y({
    ref: u,
    "aria-labelledby": o ? void 0 : h.current,
    "aria-label": o ? t : void 0,
    size: i
  }, d)), !o && e.createElement("div", {
    className: a,
    id: h.current,
    "aria-hidden": "true"
  }, t));
}),
    Ye = e.forwardRef(function (_ref72, N) {
  var _ref72$baseName = _ref72.baseName,
      t = _ref72$baseName === void 0 ? "nds-switch" : _ref72$baseName,
      r = _ref72.labelClass,
      n = _ref72.descriptionClass,
      _ref72$checked = _ref72.checked,
      a = _ref72$checked === void 0 ? !1 : _ref72$checked,
      s = _ref72.tooltipProps,
      o = _ref72.children,
      i = _ref72.className,
      l = _ref72.description,
      d = _ref72.disabled,
      _ref72$displayDefault = _ref72.displayDefault,
      u = _ref72$displayDefault === void 0 ? !0 : _ref72$displayDefault,
      m = _ref72.label,
      p = _ref72.tipped,
      f = _ref72.id,
      v = _ref72.labelId,
      b = _ref72.descriptionId,
      g = _ref72.onClick,
      E = _ref72.onToggle,
      w = _objectWithoutProperties(_ref72, _excluded33);

  var _e$useState55 = e.useState(a),
      _e$useState56 = _slicedToArray(_e$useState55, 2),
      C = _e$useState56[0],
      _ = _e$useState56[1],
      _e$useState57 = e.useState("OFF"),
      _e$useState58 = _slicedToArray(_e$useState57, 2),
      x = _e$useState58[0],
      M = _e$useState58[1],
      L = e.useRef(C),
      _k19 = k(N),
      _k20 = _slicedToArray(_k19, 2),
      $ = _k20[0],
      O = _k20[1],
      S = e.useRef(f || h("".concat(t, "-"))),
      R = e.useRef(v || "".concat(S.current, "-label")),
      z = e.useRef(b || "".concat(S.current, "-desc"));

  e.useEffect(function () {
    return _(a);
  }, [a]), e.useEffect(function () {
    M(C ? "ON" : "OFF"), E && C !== L.current && E(C), L.current = C;
  }, [C, E]);
  var I = p ? e.createElement(ne, y({
    asLabel: !0,
    reference: $
  }, s), m) : e.createElement(fe, {
    htmlFor: S.current,
    label: m,
    labelClass: r,
    labelId: R.current,
    description: l,
    descriptionClass: n,
    descriptionId: z.current
  }),
      B = p ? w : _objectSpread({
    id: S.current,
    "aria-labelledby": "".concat(S.current, "-label")
  }, w);
  return e.createElement("div", {
    className: t
  }, I, e.createElement(ce, y({
    "aria-checked": C ? "true" : "false",
    className: c("".concat(t, "__control"), i),
    disabled: d,
    onClick: function onClick(e) {
      g ? g(e) : _(!C);
    },
    ref: O,
    role: "switch"
  }, B), o || (u ? x : void 0)));
}),
    Je = e.forwardRef(function (_ref73, m) {
  var _c11;

  var t = _ref73.dismissible,
      _ref73$baseName = _ref73.baseName,
      r = _ref73$baseName === void 0 ? "nds-tag" : _ref73$baseName,
      _ref73$contentsClass = _ref73.contentsClass,
      n = _ref73$contentsClass === void 0 ? "".concat(r, "__contents") : _ref73$contentsClass,
      _ref73$dismissClass = _ref73.dismissClass,
      a = _ref73$dismissClass === void 0 ? "".concat(r, "__dismiss") : _ref73$dismissClass,
      s = _ref73.children,
      o = _ref73.color,
      i = _ref73.onDismiss,
      l = _ref73.onClick,
      d = _ref73.className,
      u = _objectWithoutProperties(_ref73, _excluded34);

  var h = e.useMemo(function () {
    return M(s);
  }, [s]),
      p = c(d, r, (_c11 = {}, _defineProperty(_c11, "".concat(r, "--").concat(o), void 0 !== o), _defineProperty(_c11, "".concat(r, "--dismissible"), !0 === t), _c11));

  if (t) {
    var _t4 = M(s) ? s.props.children : s;

    return e.createElement("span", y({
      className: p,
      ref: m
    }, u), e.createElement("span", {
      className: n
    }, _t4), e.createElement(U, {
      className: a,
      onClick: function onClick(e) {
        i ? i() : l && l(e);
      }
    }, e.createElement(ae, {
      variant: "close",
      size: "0.85em",
      "aria-label": "Dismiss"
    })));
  }

  return h ? e.createElement("span", y({
    className: p,
    ref: m
  }, u), e.createElement("span", {
    className: n
  }, s)) : e.createElement(U, y({
    className: p,
    onClick: l
  }, u), e.createElement("span", {
    className: n
  }, s));
}),
    Qe = {
  validateOnDOMChange: !0
},
    Xe = e.forwardRef(function (_ref74, h) {
  var _ref74$multiline = _ref74.multiline,
      t = _ref74$multiline === void 0 ? !1 : _ref74$multiline,
      _ref74$autoSize = _ref74.autoSize,
      r = _ref74$autoSize === void 0 ? !1 : _ref74$autoSize,
      n = _ref74.errors,
      a = _ref74.validateOnChange,
      _ref74$validateOnDOMC = _ref74.validateOnDOMChange,
      s = _ref74$validateOnDOMC === void 0 ? Qe.validateOnDOMChange : _ref74$validateOnDOMC,
      o = _ref74.validators,
      i = _ref74.maxLength,
      _ref74$maxLengthRestr = _ref74.maxLengthRestrictsInput,
      l = _ref74$maxLengthRestr === void 0 ? !1 : _ref74$maxLengthRestr,
      c = _ref74.onInput,
      d = _ref74.onDOMChange,
      u = _ref74.onValidate,
      m = _objectWithoutProperties(_ref74, _excluded35);

  var _k21 = k(h),
      _k22 = _slicedToArray(_k21, 2),
      p = _k22[0],
      f = _k22[1],
      _e$useState59 = e.useState(n),
      _e$useState60 = _slicedToArray(_e$useState59, 2),
      v = _e$useState60[0],
      b = _e$useState60[1],
      g = Number(t) > 0 ? Number(t) : 1;

  e.useEffect(function () {
    return b(n);
  }, [n]);
  var E = F(o),
      w = e.useCallback(function (_ref75) {
    var e = _ref75.maxLength,
        t = _ref75.minLength,
        r = _ref75.required,
        a = _ref75.type,
        s = _ref75.value,
        o = _ref75.validity;
    var l = E({
      maxLength: i || e,
      minLength: t,
      required: r,
      type: a,
      value: s,
      validity: o
    });
    u && u(l), n || b(l);
  }, [E, u, n, i]);
  e.useEffect(function () {
    r && p && (p.style.height = "auto");
  }, [r, p]);
  var N = e.useCallback(function (e) {
    d && d(e), s && w(e.target);
  }, [d, s, w]);
  return e.useEffect(function () {
    if (p && p.willValidate) {
      var _e11 = v && v.length ? v.join("\n") : "";

      p.setCustomValidity(_e11);
    }
  }, [p, v]), O(function () {
    return p && N && p.addEventListener("change", N), function () {
      p && N && p.removeEventListener("change", N);
    };
  }, [p, N]), e.createElement("textarea", y({
    ref: f,
    rows: g,
    onInput: function onInput(e) {
      c && c(e), r && p && (p.style.height = "auto", p.style.height = "".concat(p.scrollHeight, "px")), a && w(e.currentTarget);
    },
    maxLength: l ? i : void 0
  }, m));
});

Xe.defaultProps = Qe;

var et = function et(_ref76) {
  var e = _ref76.remaining,
      t = _ref76.max;
  return e < 0 ? null : "".concat(e, "/").concat(t, " characters remaining");
},
    tt = e.forwardRef(function (_ref77, q) {
  var _ref77$counterStart = _ref77.counterStart,
      t = _ref77$counterStart === void 0 ? 25 : _ref77$counterStart,
      r = _ref77.validators,
      n = _ref77.validateOnChange,
      a = _ref77.validateOnDOMChange,
      s = _ref77.requiredIndicator,
      o = _ref77.optionalIndicator,
      _ref77$multiline = _ref77.multiline,
      i = _ref77$multiline === void 0 ? !1 : _ref77$multiline,
      _ref77$autoSize = _ref77.autoSize,
      l = _ref77$autoSize === void 0 ? !1 : _ref77$autoSize,
      d = _ref77.children,
      u = _ref77.description,
      m = _ref77.addonBefore,
      p = _ref77.addonAfter,
      f = _ref77.feedback,
      v = _ref77.errors,
      _ref77$counter = _ref77.counter,
      b = _ref77$counter === void 0 ? et : _ref77$counter,
      _ref77$baseName = _ref77.baseName,
      g = _ref77$baseName === void 0 ? "nds-field" : _ref77$baseName,
      _ref77$className = _ref77.className,
      E = _ref77$className === void 0 ? c(g, "".concat(g, "--text")) : _ref77$className,
      w = _ref77.labelClass,
      N = _ref77.descriptionClass,
      _ref77$groupClass = _ref77.groupClass,
      C = _ref77$groupClass === void 0 ? c("".concat(g, "__group").concat(i ? "--textarea" : ""), "".concat(g, "__group--text")) : _ref77$groupClass,
      _ref77$inputClass = _ref77.inputClass,
      _ = _ref77$inputClass === void 0 ? c("".concat(g, "__").concat(i ? "textarea" : "input"), "".concat(g, "__").concat(i ? "textarea" : "input", "--text")) : _ref77$inputClass,
      _ref77$addonClass = _ref77.addonClass,
      k = _ref77$addonClass === void 0 ? "".concat(g, "__addon") : _ref77$addonClass,
      x = _ref77.feedbackClass,
      M = _ref77.errorsClass,
      _ref77$counterClass = _ref77.counterClass,
      L = _ref77$counterClass === void 0 ? "".concat(g, "__counter") : _ref77$counterClass,
      _ref77$invalidClass = _ref77.invalidClass,
      $ = _ref77$invalidClass === void 0 ? "".concat(g, "--invalid") : _ref77$invalidClass,
      O = _ref77.id,
      S = _ref77.labelId,
      R = _ref77.descriptionId,
      z = _ref77.errorsId,
      I = _ref77.maxLength,
      B = _ref77.required,
      _ref77$type = _ref77.type,
      P = _ref77$type === void 0 ? "text" : _ref77$type,
      D = _ref77.value,
      A = _ref77.onChange,
      H = _ref77.onCount,
      T = _ref77.onDOMChange,
      V = _ref77.onValidate,
      F = _objectWithoutProperties(_ref77, _excluded36);

  var _e$useState61 = e.useState(v),
      _e$useState62 = _slicedToArray(_e$useState61, 2),
      U = _e$useState62[0],
      K = _e$useState62[1],
      W = e.useRef(O || h("".concat(g, "-"))),
      j = e.useRef(S || "".concat(W.current, "-label")),
      G = e.useRef(R || "".concat(W.current, "-desc")),
      Z = e.useRef(z || "".concat(W.current, "-err")),
      Y = e.useRef("".concat(W.current, "-input")),
      J = e.useCallback(function (e) {
    if (I) return I - (e || "").toString().length;
  }, [I]),
      _e$useState63 = e.useState(J(D)),
      _e$useState64 = _slicedToArray(_e$useState63, 2),
      Q = _e$useState64[0],
      X = _e$useState64[1];

  e.useEffect(function () {
    return X(J(D));
  }, [J, D]), e.useEffect(function () {
    return K(v);
  }, [v]), e.useEffect(function () {
    H && H(Q);
  }, [H, Q]);

  var ee = e.useMemo(function () {
    return Boolean(!U || 0 === U.length);
  }, [U]),
      te = function te(t) {
    return t ? e.Children.map(t, function (t) {
      return e.isValidElement(t) && t.type === e.Fragment ? te(t.props.children) : e.createElement(be, {
        className: k
      }, t);
    }) : null;
  },
      re = e.useMemo(function () {
    return b && void 0 !== I && void 0 !== Q && void 0 !== t && Q <= t ? e.createElement("div", {
      className: L
    }, b({
      remaining: Q,
      max: I
    })) : null;
  }, [b, L, t, I, Q]),
      ne = e.useMemo(function () {
    return s && B ? "required" : o && !B ? "optional" : null;
  }, [s, o, B]),
      ae = _objectSpread({
    ref: q,
    value: D,
    errors: U,
    onChange: function onChange(e) {
      A ? A(e) : X(J(e.target.value));
    },
    onDOMChange: T,
    onValidate: function onValidate(e) {
      V && V(e), K(e);
    },
    id: Y.current,
    className: _,
    "aria-describedby": u ? G.current : void 0,
    "aria-invalid": !ee,
    "aria-errormessage": ee ? void 0 : Z.current,
    maxLength: I,
    required: B,
    validators: r,
    validateOnChange: n,
    validateOnDOMChange: a
  }, F);

  return e.createElement("div", {
    className: c(E, _defineProperty({}, $, !ee)),
    id: W.current
  }, e.createElement(fe, {
    htmlFor: Y.current,
    label: d,
    indicator: ne,
    labelId: j.current,
    labelClass: w,
    descriptionClass: N,
    descriptionId: G.current,
    description: u
  }), e.createElement("div", {
    className: i ? "" : C
  }, i ? e.createElement(Xe, y({}, ae, {
    className: c(C, _),
    multiline: i,
    autoSize: l
  })) : e.createElement(e.Fragment, null, te(m), e.createElement(Ee, y({}, ae, {
    type: P
  })), te(p))), e.createElement(ve, {
    className: x,
    errorsId: Z.current,
    errors: U,
    errorsClass: M
  }, f, re));
}),
    rt = function rt(t) {
  var _e$useState65 = e.useState(""),
      _e$useState66 = _slicedToArray(_e$useState65, 2),
      r = _e$useState66[0],
      n = _e$useState66[1];

  return e.createElement(tt, y({
    value: r,
    onChange: function onChange(e) {
      n(e.target.value);
      var r = t.onChange;
      r && r(e);
    }
  }, t));
},
    nt = function nt(_ref78) {
  var t = _ref78.colorScheme,
      r = _ref78.ignoreOSColorScheme,
      n = _ref78.onColorSchemeChange,
      a = _ref78.children;

  var s = e.useContext(P),
      o = s ? s.colorScheme : void 0,
      i = void 0 === s,
      l = S("(prefers-color-scheme: dark)"),
      c = e.useMemo(function () {
    return l ? "dark" : "light";
  }, [l]),
      d = e.useRef(c),
      _e$useState67 = e.useState(function (e, t) {
    if ("inverse" === e) {
      if (t) return "light" === t ? "dark" : "light";
      throw new Error("colorScheme cannot be inverted on the root <ThemeProvider>.");
    }

    return e || "light";
  }(t || (r ? void 0 : c), o)),
      _e$useState68 = _slicedToArray(_e$useState67, 2),
      u = _e$useState68[0],
      m = _e$useState68[1];

  return e.useEffect(function () {
    !r && i && c !== d.current && (m(c), d.current = c);
  }, [i, c, r]), O(function () {
    i && (u ? document.documentElement.setAttribute("data-color-scheme", u) : document.documentElement.removeAttribute("data-color-scheme"));
  }, [u, i]), e.useEffect(function () {
    o && "inverse" === t && m("dark" === o ? "light" : "dark");
  }, [o, t]), e.useEffect(function () {
    n && n(u);
  }, [u, n]), e.createElement(P.Provider, {
    value: {
      colorScheme: u,
      setColorScheme: function setColorScheme(e) {
        return m(e);
      }
    }
  }, i ? a : e.createElement("div", {
    "data-color-scheme": u
  }, a));
},
    at = function at(_ref79) {
  var t = _ref79.linkComponent,
      r = _ref79.colorScheme,
      n = _ref79.ignoreOSColorScheme,
      a = _ref79.onColorSchemeChange,
      s = _ref79.children;
  return e.createElement(x.Provider, {
    value: t
  }, e.createElement(nt, {
    colorScheme: r,
    ignoreOSColorScheme: n,
    onColorSchemeChange: a
  }, s));
};

export { at as AppProvider, w as Badge, ce as Button, ue as Callout, me as CalloutError, he as CalloutSuccess, pe as CalloutWarning, Ce as Checkbox, _e as CheckboxGroup, ye as Choice, Ne as ChoiceField, we as Choices, Le as Disclosure, Re as Dropdown, be as FieldAddon, ve as FieldFeedback, fe as FieldInfo, ae as Icon, de as IconButton, j as IconOptions, ze as Link, x as LinkContext, Be as Listbox, ie as LiveRegion, He as Modal, Ie as Option, Te as Popover, We as ProgressBar, je as Radio, Ge as RadioGroup, Ze as Spinner, Ye as Switch, Je as Tag, tt as TextField, rt as TextFieldUncontrolled, P as ThemeContext, nt as ThemeProvider, ne as Tooltip, C as canUseDOM, G as findIcon, W as icons, M as isLinkElement, N as toElements, le as useContentMonitor, _ as useExternalClick, k as useForwardedRef, $ as useIsomorphicLayoutEffect, O as useLayoutEffect, L as useLink, S as useMediaQuery, R as usePopper, z as usePopperTriggers, I as useRovingTabindex, B as useSelect, D as useTheme, F as useValidation, K as viewBox };